"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.SUNRISE_PLANS = exports.EDITOR_X_PLANS = exports.UNLIMITED_TO_CORE_PLANS = exports.STUDIO_ENTERPRISE_PLANS = exports.STUDIO_ELITE_PLANS = exports.STUDIO_PLUS_PLANS = exports.STUDIO_STANDARD_PLANS = exports.STUDIO_BASIC_PLANS = exports.advancedPlansProductMarketingData = exports.getAllEditorXProductKeys = exports.getAllAdvancedProductKeys = void 0;
var types_1 = require("../../../types");
var getAllAdvancedProductKeys = function () {
    return Object.entries(exports.advancedPlansProductMarketingData)
        .filter(function (e) { return !e[1].isEditorX; })
        .map(function (e) { return e[0]; });
};
exports.getAllAdvancedProductKeys = getAllAdvancedProductKeys;
var getAllEditorXProductKeys = function () {
    return Object.entries(exports.advancedPlansProductMarketingData)
        .filter(function (e) { return e[1].isEditorX; })
        .map(function (e) { return e[0]; });
};
exports.getAllEditorXProductKeys = getAllEditorXProductKeys;
exports.advancedPlansProductMarketingData = {
    10004: {
        productFamily: types_1.ProductFamily.Dayful,
        type: types_1.PlanType.Website,
        productCode: types_1.ProductCode.DAYFUL_FREE,
        description: 'description',
    },
    10003: {
        productFamily: types_1.ProductFamily.Basic,
        type: types_1.PlanType.Website,
        productCode: types_1.ProductCode.DAYFUL_BASIC,
        description: 'description',
    },
    10002: {
        productFamily: types_1.ProductFamily.Standard,
        type: types_1.PlanType.Website,
        productCode: types_1.ProductCode.DAYFUL_STANDARD,
        description: 'description',
    },
    10001: {
        productFamily: types_1.ProductFamily.Advanced,
        type: types_1.PlanType.Website,
        productCode: types_1.ProductCode.DAYFUL_ADVANCED,
        description: 'description',
    },
    999: {
        productFamily: types_1.ProductFamily.Evolve,
        type: types_1.PlanType.Business,
        productCode: types_1.ProductCode.BUSINESS_EVOLVE,
        description: 'description',
    },
    991: {
        productFamily: types_1.ProductFamily.Grow,
        type: types_1.PlanType.Business,
        productCode: types_1.ProductCode.BUSINESS_GROW,
        description: 'description',
    },
    992: {
        productFamily: types_1.ProductFamily.Sell,
        type: types_1.PlanType.Business,
        productCode: types_1.ProductCode.BUSINESS_SELL,
        description: 'description',
    },
    993: {
        productFamily: types_1.ProductFamily.Pro,
        type: types_1.PlanType.Website,
        productCode: types_1.ProductCode.WEBSITE_PRO,
        description: 'description',
    },
    994: {
        productFamily: types_1.ProductFamily.Unlimited,
        type: types_1.PlanType.Website,
        productCode: types_1.ProductCode.WEBSITE_UNLIMITED,
        description: 'description',
    },
    995: {
        productFamily: types_1.ProductFamily.Default,
        type: types_1.PlanType.Website,
        productCode: types_1.ProductCode.WEBSITE_COMBO,
        description: 'description',
    },
    996: {
        productFamily: types_1.ProductFamily.VIP,
        type: types_1.PlanType.Website,
        productCode: types_1.ProductCode.WEBSITE_VIP,
        description: 'description',
        shouldShowAdsNote: true,
    },
    501: {
        productFamily: types_1.ProductFamily.Combo,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_COMBO, ".description"),
        productCode: types_1.ProductCode.WEBSITE_COMBO,
    },
    502: {
        productFamily: types_1.ProductFamily.Unlimited,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_UNLIMITED, ".description"),
        productCode: types_1.ProductCode.WEBSITE_UNLIMITED,
    },
    503: {
        productFamily: types_1.ProductFamily.Pro,
        hatKey: 'product.best_value',
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_PRO, ".description"),
        productCode: types_1.ProductCode.WEBSITE_PRO,
    },
    504: {
        productFamily: types_1.ProductFamily.VIP,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_VIP, ".description"),
        productCode: types_1.ProductCode.WEBSITE_VIP,
    },
    505: {
        productFamily: types_1.ProductFamily.Sell,
        type: types_1.PlanType.Business,
        description: 'Advanced.Plans_Business_Sell_description',
        productCode: types_1.ProductCode.BUSINESS_SELL,
    },
    506: {
        productFamily: types_1.ProductFamily.Grow,
        type: types_1.PlanType.Business,
        description: 'Advanced.Plans_Business_Grow_description',
        productCode: types_1.ProductCode.BUSINESS_GROW,
    },
    507: {
        productFamily: types_1.ProductFamily.Evolve,
        type: types_1.PlanType.Business,
        description: 'Advanced.Plans_Business_Evolve_description',
        productCode: types_1.ProductCode.BUSINESS_EVOLVE,
    },
    508: {
        productFamily: types_1.ProductFamily.Sell,
        type: types_1.PlanType.Business,
        description: 'Advanced.Plans_Business_Sell_description',
        productCode: types_1.ProductCode.BUSINESS_SELL,
        firstPeriodDiscount: 20,
    },
    509: {
        productFamily: types_1.ProductFamily.Grow,
        type: types_1.PlanType.Business,
        description: 'Advanced.Plans_Business_Grow_description',
        productCode: types_1.ProductCode.BUSINESS_GROW,
        firstPeriodDiscount: 20,
    },
    510: {
        productFamily: types_1.ProductFamily.Evolve,
        type: types_1.PlanType.Business,
        description: 'Advanced.Plans_Business_Evolve_description',
        productCode: types_1.ProductCode.BUSINESS_EVOLVE,
        firstPeriodDiscount: 20,
    },
    511: {
        productFamily: types_1.ProductFamily.ConnectDomain,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_CONNECT_DOMAIN, ".description"),
        productCode: types_1.ProductCode.WEBSITE_CONNECT_DOMAIN,
        shouldShowAdsNote: true,
    },
    512: {
        productFamily: types_1.ProductFamily.Combo,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_COMBO, ".description"),
        productCode: types_1.ProductCode.WEBSITE_COMBO,
    },
    513: {
        productFamily: types_1.ProductFamily.Unlimited,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_UNLIMITED, ".description"),
        productCode: types_1.ProductCode.WEBSITE_UNLIMITED,
    },
    514: {
        productFamily: types_1.ProductFamily.VIP,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_VIP, ".description"),
        productCode: types_1.ProductCode.WEBSITE_VIP,
    },
    515: {
        productFamily: types_1.ProductFamily.Sell,
        type: types_1.PlanType.Business,
        description: 'Advanced.Plans_Business_Sell_description',
        productCode: types_1.ProductCode.BUSINESS_SELL,
    },
    516: {
        productFamily: types_1.ProductFamily.Grow,
        type: types_1.PlanType.Business,
        description: 'Advanced.Plans_Business_Grow_description',
        productCode: types_1.ProductCode.BUSINESS_GROW,
    },
    517: {
        productFamily: types_1.ProductFamily.Evolve,
        type: types_1.PlanType.Business,
        description: 'Advanced.Plans_Business_Evolve_description',
        productCode: types_1.ProductCode.BUSINESS_EVOLVE,
    },
    518: {
        productFamily: types_1.ProductFamily.Sell,
        type: types_1.PlanType.Business,
        description: 'Advanced.Plans_Business_Sell_description',
        productCode: types_1.ProductCode.BUSINESS_SELL,
        firstPeriodDiscount: 20,
    },
    519: {
        productFamily: types_1.ProductFamily.Grow,
        type: types_1.PlanType.Business,
        description: 'Advanced.Plans_Business_Grow_description',
        productCode: types_1.ProductCode.BUSINESS_GROW,
        firstPeriodDiscount: 20,
    },
    520: {
        productFamily: types_1.ProductFamily.Evolve,
        type: types_1.PlanType.Business,
        description: 'Advanced.Plans_Business_Evolve_description',
        productCode: types_1.ProductCode.BUSINESS_EVOLVE,
        firstPeriodDiscount: 20,
    },
    521: {
        productFamily: types_1.ProductFamily.ConnectDomain,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_CONNECT_DOMAIN, ".description"),
        productCode: types_1.ProductCode.WEBSITE_CONNECT_DOMAIN,
        shouldShowAdsNote: true,
    },
    522: {
        productFamily: types_1.ProductFamily.Combo,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_COMBO, ".description"),
        productCode: types_1.ProductCode.WEBSITE_COMBO,
    },
    523: {
        productFamily: types_1.ProductFamily.Unlimited,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_UNLIMITED, ".description"),
        productCode: types_1.ProductCode.WEBSITE_UNLIMITED,
    },
    524: {
        productFamily: types_1.ProductFamily.VIP,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_VIP, ".description"),
        productCode: types_1.ProductCode.WEBSITE_VIP,
    },
    525: {
        productFamily: types_1.ProductFamily.Sell,
        type: types_1.PlanType.Business,
        description: 'Advanced.Plans_Business_Sell_description',
        productCode: types_1.ProductCode.BUSINESS_SELL,
    },
    526: {
        productFamily: types_1.ProductFamily.Grow,
        type: types_1.PlanType.Business,
        description: 'Advanced.Plans_Business_Grow_description',
        productCode: types_1.ProductCode.BUSINESS_GROW,
    },
    527: {
        productFamily: types_1.ProductFamily.Evolve,
        type: types_1.PlanType.Business,
        description: 'Advanced.Plans_Business_Evolve_description',
        productCode: types_1.ProductCode.BUSINESS_EVOLVE,
    },
    528: {
        productFamily: types_1.ProductFamily.Sell,
        type: types_1.PlanType.Business,
        description: 'Advanced.Plans_Business_Sell_description',
        productCode: types_1.ProductCode.BUSINESS_SELL,
        firstPeriodDiscount: 20,
    },
    529: {
        productFamily: types_1.ProductFamily.Grow,
        type: types_1.PlanType.Business,
        description: 'Advanced.Plans_Business_Grow_description',
        productCode: types_1.ProductCode.BUSINESS_GROW,
        firstPeriodDiscount: 20,
    },
    530: {
        productFamily: types_1.ProductFamily.Evolve,
        type: types_1.PlanType.Business,
        description: 'Advanced.Plans_Business_Evolve_description',
        productCode: types_1.ProductCode.BUSINESS_EVOLVE,
        firstPeriodDiscount: 20,
    },
    531: {
        productFamily: types_1.ProductFamily.Combo,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_COMBO, ".description"),
        productCode: types_1.ProductCode.WEBSITE_COMBO,
    },
    532: {
        productFamily: types_1.ProductFamily.Unlimited,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_UNLIMITED, ".description"),
        productCode: types_1.ProductCode.WEBSITE_UNLIMITED,
    },
    533: {
        productFamily: types_1.ProductFamily.Pro,
        hatKey: 'product.best_value',
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_PRO, ".description"),
        productCode: types_1.ProductCode.WEBSITE_PRO,
    },
    534: {
        productFamily: types_1.ProductFamily.VIP,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_VIP, ".description"),
        productCode: types_1.ProductCode.WEBSITE_VIP,
    },
    535: {
        productFamily: types_1.ProductFamily.Sell,
        type: types_1.PlanType.Business,
        description: 'Advanced.Plans_Business_Sell_description',
        productCode: types_1.ProductCode.BUSINESS_SELL,
    },
    536: {
        productFamily: types_1.ProductFamily.Grow,
        type: types_1.PlanType.Business,
        description: 'Advanced.Plans_Business_Grow_description',
        productCode: types_1.ProductCode.BUSINESS_GROW,
    },
    537: {
        productFamily: types_1.ProductFamily.Evolve,
        type: types_1.PlanType.Business,
        description: 'Advanced.Plans_Business_Evolve_description',
        productCode: types_1.ProductCode.BUSINESS_EVOLVE,
    },
    538: {
        productFamily: types_1.ProductFamily.Sell,
        type: types_1.PlanType.Business,
        description: 'Advanced.Plans_Business_Sell_description',
        productCode: types_1.ProductCode.BUSINESS_SELL,
        firstPeriodDiscount: 20,
    },
    539: {
        productFamily: types_1.ProductFamily.Grow,
        type: types_1.PlanType.Business,
        description: 'Advanced.Plans_Business_Grow_description',
        productCode: types_1.ProductCode.BUSINESS_GROW,
        firstPeriodDiscount: 20,
    },
    540: {
        productFamily: types_1.ProductFamily.Evolve,
        type: types_1.PlanType.Business,
        description: 'Advanced.Plans_Business_Evolve_description',
        productCode: types_1.ProductCode.BUSINESS_EVOLVE,
        firstPeriodDiscount: 20,
    },
    541: {
        productFamily: types_1.ProductFamily.ConnectDomain,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_CONNECT_DOMAIN, ".description"),
        productCode: types_1.ProductCode.WEBSITE_CONNECT_DOMAIN,
        shouldShowAdsNote: true,
    },
    542: {
        productFamily: types_1.ProductFamily.Combo,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_COMBO, ".description"),
        productCode: types_1.ProductCode.WEBSITE_COMBO,
    },
    543: {
        productFamily: types_1.ProductFamily.Unlimited,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_UNLIMITED, ".description"),
        productCode: types_1.ProductCode.WEBSITE_UNLIMITED,
    },
    544: {
        productFamily: types_1.ProductFamily.VIP,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_VIP, ".description"),
        productCode: types_1.ProductCode.WEBSITE_VIP,
    },
    545: {
        productFamily: types_1.ProductFamily.Sell,
        type: types_1.PlanType.Business,
        description: 'Advanced.Plans_Business_Sell_description',
        productCode: types_1.ProductCode.BUSINESS_SELL,
    },
    546: {
        productFamily: types_1.ProductFamily.Grow,
        type: types_1.PlanType.Business,
        description: 'Advanced.Plans_Business_Grow_description',
        productCode: types_1.ProductCode.BUSINESS_GROW,
    },
    547: {
        productFamily: types_1.ProductFamily.Evolve,
        type: types_1.PlanType.Business,
        description: 'Advanced.Plans_Business_Evolve_description',
        productCode: types_1.ProductCode.BUSINESS_EVOLVE,
    },
    548: {
        productFamily: types_1.ProductFamily.Sell,
        type: types_1.PlanType.Business,
        description: 'Advanced.Plans_Business_Sell_description',
        productCode: types_1.ProductCode.BUSINESS_SELL,
        firstPeriodDiscount: 20,
    },
    549: {
        productFamily: types_1.ProductFamily.Grow,
        type: types_1.PlanType.Business,
        description: 'Advanced.Plans_Business_Grow_description',
        productCode: types_1.ProductCode.BUSINESS_GROW,
        firstPeriodDiscount: 20,
    },
    550: {
        productFamily: types_1.ProductFamily.Evolve,
        type: types_1.PlanType.Business,
        description: 'Advanced.Plans_Business_Evolve_description',
        productCode: types_1.ProductCode.BUSINESS_EVOLVE,
        firstPeriodDiscount: 20,
    },
    9999: {
        productFamily: types_1.ProductFamily.Enterprise,
        type: types_1.PlanType.Business,
        description: 'Advanced.Plans_Business_Enterprise_description',
        productCode: types_1.ProductCode.BUSINESS_ENTERPRISE,
    },
    9998: {
        productFamily: types_1.ProductFamily.Enterprise,
        type: types_1.PlanType.Business,
        description: 'Advanced.Plans_Business_Enterprise_description',
        productCode: types_1.ProductCode.BUSINESS_ENTERPRISE,
        isEditorX: true,
    },
    551: {
        productFamily: types_1.ProductFamily.Essential,
        type: types_1.PlanType.Website,
        description: "Editorx.Plans_website_essential_description",
        productCode: types_1.ProductCode.WEBSITE_ESSENTIAL,
        isEditorX: true,
    },
    552: {
        productFamily: types_1.ProductFamily.Extra,
        hatKey: 'product.best_value',
        type: types_1.PlanType.Website,
        description: "Editorx.Plans_website_extra_description",
        productCode: types_1.ProductCode.WEBSITE_EXTRA,
        isEditorX: true,
    },
    553: {
        productFamily: types_1.ProductFamily.Ultra,
        type: types_1.PlanType.Website,
        description: "Editorx.Plans_website_ultra_description",
        productCode: types_1.ProductCode.WEBSITE_ULTRA,
        isEditorX: true,
    },
    554: {
        productFamily: types_1.ProductFamily.Launch,
        type: types_1.PlanType.Business,
        description: 'Editorx.Plans_business_launch_description',
        productCode: types_1.ProductCode.BUSINESS_LAUNCH,
        isEditorX: true,
    },
    555: {
        productFamily: types_1.ProductFamily.Boost,
        type: types_1.PlanType.Business,
        description: 'Editorx.Plans_business_boost_description',
        hatKey: 'product.best_value',
        productCode: types_1.ProductCode.BUSINESS_BOOST,
        isEditorX: true,
    },
    556: {
        productFamily: types_1.ProductFamily.Scale,
        type: types_1.PlanType.Business,
        description: 'Editorx.Plans_business_scale_description',
        productCode: types_1.ProductCode.BUSINESS_SCALE,
        isEditorX: true,
    },
    582: {
        productFamily: types_1.ProductFamily.Essential,
        type: types_1.PlanType.Website,
        description: "Editorx.Plans_website_essential_description",
        productCode: types_1.ProductCode.WEBSITE_ESSENTIAL,
        isEditorX: true,
    },
    583: {
        productFamily: types_1.ProductFamily.Extra,
        hatKey: 'product.best_value',
        type: types_1.PlanType.Website,
        description: "Editorx.Plans_website_extra_description",
        productCode: types_1.ProductCode.WEBSITE_EXTRA,
        isEditorX: true,
    },
    584: {
        productFamily: types_1.ProductFamily.Ultra,
        type: types_1.PlanType.Website,
        description: "Editorx.Plans_website_ultra_description",
        productCode: types_1.ProductCode.WEBSITE_ULTRA,
        isEditorX: true,
    },
    585: {
        productFamily: types_1.ProductFamily.Launch,
        type: types_1.PlanType.Business,
        description: 'Editorx.Plans_business_launch_description',
        productCode: types_1.ProductCode.BUSINESS_LAUNCH,
        isEditorX: true,
    },
    586: {
        productFamily: types_1.ProductFamily.Boost,
        type: types_1.PlanType.Business,
        description: 'Editorx.Plans_business_boost_description',
        hatKey: 'product.best_value',
        productCode: types_1.ProductCode.BUSINESS_BOOST,
        isEditorX: true,
    },
    587: {
        productFamily: types_1.ProductFamily.Scale,
        type: types_1.PlanType.Business,
        description: 'Editorx.Plans_business_scale_description',
        productCode: types_1.ProductCode.BUSINESS_SCALE,
        isEditorX: true,
    },
    588: {
        productFamily: types_1.ProductFamily.Essential,
        type: types_1.PlanType.Website,
        description: "Editorx.Plans_website_essential_description",
        productCode: types_1.ProductCode.WEBSITE_ESSENTIAL,
        isEditorX: true,
    },
    589: {
        productFamily: types_1.ProductFamily.Extra,
        hatKey: 'product.best_value',
        type: types_1.PlanType.Website,
        description: "Editorx.Plans_website_extra_description",
        productCode: types_1.ProductCode.WEBSITE_EXTRA,
        isEditorX: true,
    },
    590: {
        productFamily: types_1.ProductFamily.Ultra,
        type: types_1.PlanType.Website,
        description: "Editorx.Plans_website_ultra_description",
        productCode: types_1.ProductCode.WEBSITE_ULTRA,
        isEditorX: true,
    },
    591: {
        productFamily: types_1.ProductFamily.Launch,
        type: types_1.PlanType.Business,
        description: 'Editorx.Plans_business_launch_description',
        productCode: types_1.ProductCode.BUSINESS_LAUNCH,
        isEditorX: true,
    },
    592: {
        productFamily: types_1.ProductFamily.Boost,
        type: types_1.PlanType.Business,
        description: 'Editorx.Plans_business_boost_description',
        hatKey: 'product.best_value',
        productCode: types_1.ProductCode.BUSINESS_BOOST,
        isEditorX: true,
    },
    593: {
        productFamily: types_1.ProductFamily.Scale,
        type: types_1.PlanType.Business,
        description: 'Editorx.Plans_business_scale_description',
        productCode: types_1.ProductCode.BUSINESS_SCALE,
        isEditorX: true,
    },
    594: {
        productFamily: types_1.ProductFamily.Essential,
        type: types_1.PlanType.Website,
        description: "Editorx.Plans_website_essential_description",
        productCode: types_1.ProductCode.WEBSITE_ESSENTIAL,
        isEditorX: true,
    },
    595: {
        productFamily: types_1.ProductFamily.Extra,
        hatKey: 'product.best_value',
        type: types_1.PlanType.Website,
        description: "Editorx.Plans_website_extra_description",
        productCode: types_1.ProductCode.WEBSITE_EXTRA,
        isEditorX: true,
    },
    596: {
        productFamily: types_1.ProductFamily.Ultra,
        type: types_1.PlanType.Website,
        description: "Editorx.Plans_website_ultra_description",
        productCode: types_1.ProductCode.WEBSITE_ULTRA,
        isEditorX: true,
    },
    597: {
        productFamily: types_1.ProductFamily.Launch,
        type: types_1.PlanType.Business,
        description: 'Editorx.Plans_business_launch_description',
        productCode: types_1.ProductCode.BUSINESS_LAUNCH,
        isEditorX: true,
    },
    598: {
        productFamily: types_1.ProductFamily.Boost,
        type: types_1.PlanType.Business,
        description: 'Editorx.Plans_business_boost_description',
        hatKey: 'product.best_value',
        productCode: types_1.ProductCode.BUSINESS_BOOST,
        isEditorX: true,
    },
    599: {
        productFamily: types_1.ProductFamily.Scale,
        type: types_1.PlanType.Business,
        description: 'Editorx.Plans_business_scale_description',
        productCode: types_1.ProductCode.BUSINESS_SCALE,
        isEditorX: true,
    },
    600: {
        productFamily: types_1.ProductFamily.Essential,
        type: types_1.PlanType.Website,
        description: "Editorx.Plans_website_essential_description",
        productCode: types_1.ProductCode.WEBSITE_ESSENTIAL,
        isEditorX: true,
    },
    601: {
        productFamily: types_1.ProductFamily.Extra,
        hatKey: 'product.best_value',
        type: types_1.PlanType.Website,
        description: "Editorx.Plans_website_extra_description",
        productCode: types_1.ProductCode.WEBSITE_EXTRA,
        isEditorX: true,
    },
    602: {
        productFamily: types_1.ProductFamily.Ultra,
        type: types_1.PlanType.Website,
        description: "Editorx.Plans_website_ultra_description",
        productCode: types_1.ProductCode.WEBSITE_ULTRA,
        isEditorX: true,
    },
    603: {
        productFamily: types_1.ProductFamily.Launch,
        type: types_1.PlanType.Business,
        description: 'Editorx.Plans_business_launch_description',
        productCode: types_1.ProductCode.BUSINESS_LAUNCH,
        isEditorX: true,
    },
    604: {
        productFamily: types_1.ProductFamily.Boost,
        type: types_1.PlanType.Business,
        description: 'Editorx.Plans_business_boost_description',
        hatKey: 'product.best_value',
        productCode: types_1.ProductCode.BUSINESS_BOOST,
        isEditorX: true,
    },
    605: {
        productFamily: types_1.ProductFamily.Scale,
        type: types_1.PlanType.Business,
        description: 'Editorx.Plans_business_scale_description',
        productCode: types_1.ProductCode.BUSINESS_SCALE,
        isEditorX: true,
    },
    613: {
        productFamily: types_1.ProductFamily.Combo,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_COMBO, ".description"),
        productCode: types_1.ProductCode.WEBSITE_COMBO,
    },
    614: {
        productFamily: types_1.ProductFamily.Unlimited,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_UNLIMITED, ".description"),
        productCode: types_1.ProductCode.WEBSITE_UNLIMITED,
    },
    615: {
        productFamily: types_1.ProductFamily.Pro,
        hatKey: 'product.best_value',
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_PRO, ".description"),
        productCode: types_1.ProductCode.WEBSITE_PRO,
    },
    616: {
        productFamily: types_1.ProductFamily.VIP,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_VIP, ".description"),
        productCode: types_1.ProductCode.WEBSITE_VIP,
    },
    617: {
        productFamily: types_1.ProductFamily.Default,
        type: types_1.PlanType.Business,
        description: "premium_plan.".concat(types_1.ProductCode.BUSINESS_BASIC, ".description"),
        productCode: types_1.ProductCode.BUSINESS_BASIC,
    },
    618: {
        productFamily: types_1.ProductFamily.Unlimited,
        type: types_1.PlanType.Business,
        description: "premium_plan.".concat(types_1.ProductCode.BUSINESS_UNLIMITED, ".description"),
        productCode: types_1.ProductCode.BUSINESS_UNLIMITED,
    },
    619: {
        productFamily: types_1.ProductFamily.VIP,
        type: types_1.PlanType.Business,
        description: "premium_plan.".concat(types_1.ProductCode.BUSINESS_VIP, ".description"),
        productCode: types_1.ProductCode.BUSINESS_VIP,
    },
    647: {
        productFamily: types_1.ProductFamily.Combo,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_COMBO, ".description"),
        productCode: types_1.ProductCode.WEBSITE_COMBO,
    },
    648: {
        productFamily: types_1.ProductFamily.Unlimited,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_UNLIMITED, ".description"),
        productCode: types_1.ProductCode.WEBSITE_UNLIMITED,
    },
    649: {
        productFamily: types_1.ProductFamily.Pro,
        hatKey: 'product.best_value',
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_PRO, ".description"),
        productCode: types_1.ProductCode.WEBSITE_PRO,
    },
    650: {
        productFamily: types_1.ProductFamily.Default,
        type: types_1.PlanType.Business,
        description: "premium_plan.".concat(types_1.ProductCode.BUSINESS_BASIC, ".description"),
        productCode: types_1.ProductCode.BUSINESS_BASIC,
    },
    651: {
        productFamily: types_1.ProductFamily.Unlimited,
        type: types_1.PlanType.Business,
        description: "premium_plan.".concat(types_1.ProductCode.BUSINESS_UNLIMITED, ".description"),
        productCode: types_1.ProductCode.BUSINESS_UNLIMITED,
    },
    652: {
        productFamily: types_1.ProductFamily.ConnectDomain,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_CONNECT_DOMAIN, ".description"),
        productCode: types_1.ProductCode.WEBSITE_CONNECT_DOMAIN,
        shouldShowAdsNote: true,
    },
    653: {
        productFamily: types_1.ProductFamily.Combo,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_COMBO, ".description"),
        productCode: types_1.ProductCode.WEBSITE_COMBO,
    },
    654: {
        productFamily: types_1.ProductFamily.Unlimited,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_UNLIMITED, ".description"),
        productCode: types_1.ProductCode.WEBSITE_UNLIMITED,
    },
    655: {
        productFamily: types_1.ProductFamily.VIP,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_VIP, ".description"),
        productCode: types_1.ProductCode.WEBSITE_VIP,
    },
    656: {
        productFamily: types_1.ProductFamily.Default,
        type: types_1.PlanType.Business,
        description: "premium_plan.".concat(types_1.ProductCode.BUSINESS_BASIC, ".description"),
        productCode: types_1.ProductCode.BUSINESS_BASIC,
    },
    657: {
        productFamily: types_1.ProductFamily.Unlimited,
        type: types_1.PlanType.Business,
        description: "premium_plan.".concat(types_1.ProductCode.BUSINESS_UNLIMITED, ".description"),
        productCode: types_1.ProductCode.BUSINESS_UNLIMITED,
    },
    658: {
        productFamily: types_1.ProductFamily.VIP,
        type: types_1.PlanType.Business,
        description: "premium_plan.".concat(types_1.ProductCode.BUSINESS_VIP, ".description"),
        productCode: types_1.ProductCode.BUSINESS_VIP,
    },
    659: {
        productFamily: types_1.ProductFamily.ConnectDomain,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_CONNECT_DOMAIN, ".description"),
        productCode: types_1.ProductCode.WEBSITE_CONNECT_DOMAIN,
        shouldShowAdsNote: true,
    },
    6591: {
        productFamily: types_1.ProductFamily.ConnectDomain,
        type: types_1.PlanType.Website,
        description: 'premium-plan-purchase.plan_description.connect_domain',
        productCode: types_1.ProductCode.WEBSITE_CONNECT_DOMAIN,
        shouldShowAdsNote: true,
    },
    6592: {
        productFamily: types_1.ProductFamily.ConnectDomain,
        type: types_1.PlanType.Website,
        description: 'premium-plan-purchase.plan_description.connect_domain',
        productCode: types_1.ProductCode.WEBSITE_CONNECT_DOMAIN,
        shouldShowAdsNote: true,
    },
    6590: {
        productFamily: types_1.ProductFamily.ConnectDomain,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_CONNECT_DOMAIN, ".description"),
        productCode: types_1.ProductCode.WEBSITE_CONNECT_DOMAIN,
        shouldShowAdsNote: true,
    },
    660: {
        productFamily: types_1.ProductFamily.Combo,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_COMBO, ".description"),
        productCode: types_1.ProductCode.WEBSITE_COMBO,
    },
    6600: {
        productFamily: types_1.ProductFamily.Combo,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_COMBO, ".description"),
        productCode: types_1.ProductCode.WEBSITE_COMBO,
    },
    661: {
        productFamily: types_1.ProductFamily.Unlimited,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_UNLIMITED, ".description"),
        productCode: types_1.ProductCode.WEBSITE_UNLIMITED,
    },
    662: {
        productFamily: types_1.ProductFamily.VIP,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_VIP, ".description"),
        productCode: types_1.ProductCode.WEBSITE_VIP,
    },
    663: {
        productFamily: types_1.ProductFamily.Default,
        type: types_1.PlanType.Business,
        description: "premium_plan.".concat(types_1.ProductCode.BUSINESS_BASIC, ".description"),
        productCode: types_1.ProductCode.BUSINESS_BASIC,
    },
    664: {
        productFamily: types_1.ProductFamily.Unlimited,
        type: types_1.PlanType.Business,
        description: "premium_plan.".concat(types_1.ProductCode.BUSINESS_UNLIMITED, ".description"),
        productCode: types_1.ProductCode.BUSINESS_UNLIMITED,
    },
    665: {
        productFamily: types_1.ProductFamily.VIP,
        type: types_1.PlanType.Business,
        description: "premium_plan.".concat(types_1.ProductCode.BUSINESS_VIP, ".description"),
        productCode: types_1.ProductCode.BUSINESS_VIP,
    },
    666: {
        productFamily: types_1.ProductFamily.Combo,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_COMBO, ".description"),
        productCode: types_1.ProductCode.WEBSITE_COMBO,
    },
    667: {
        productFamily: types_1.ProductFamily.Unlimited,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_UNLIMITED, ".description"),
        productCode: types_1.ProductCode.WEBSITE_UNLIMITED,
    },
    668: {
        productFamily: types_1.ProductFamily.Pro,
        hatKey: 'product.best_value',
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_PRO, ".description"),
        productCode: types_1.ProductCode.WEBSITE_PRO,
    },
    669: {
        productFamily: types_1.ProductFamily.VIP,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_VIP, ".description"),
        productCode: types_1.ProductCode.WEBSITE_VIP,
    },
    670: {
        productFamily: types_1.ProductFamily.Default,
        type: types_1.PlanType.Business,
        description: "premium_plan.".concat(types_1.ProductCode.BUSINESS_BASIC, ".description"),
        productCode: types_1.ProductCode.BUSINESS_BASIC,
    },
    671: {
        productFamily: types_1.ProductFamily.Unlimited,
        type: types_1.PlanType.Business,
        description: "premium_plan.".concat(types_1.ProductCode.BUSINESS_UNLIMITED, ".description"),
        productCode: types_1.ProductCode.BUSINESS_UNLIMITED,
    },
    672: {
        productFamily: types_1.ProductFamily.VIP,
        type: types_1.PlanType.Business,
        description: "premium_plan.".concat(types_1.ProductCode.BUSINESS_VIP, ".description"),
        productCode: types_1.ProductCode.BUSINESS_VIP,
    },
    673: {
        productFamily: types_1.ProductFamily.ConnectDomain,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_CONNECT_DOMAIN, ".description"),
        productCode: types_1.ProductCode.WEBSITE_CONNECT_DOMAIN,
        shouldShowAdsNote: true,
    },
    674: {
        productFamily: types_1.ProductFamily.Combo,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_COMBO, ".description"),
        productCode: types_1.ProductCode.WEBSITE_COMBO,
    },
    675: {
        productFamily: types_1.ProductFamily.Unlimited,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_UNLIMITED, ".description"),
        productCode: types_1.ProductCode.WEBSITE_UNLIMITED,
    },
    676: {
        productFamily: types_1.ProductFamily.VIP,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_VIP, ".description"),
        productCode: types_1.ProductCode.WEBSITE_VIP,
    },
    677: {
        productFamily: types_1.ProductFamily.Default,
        type: types_1.PlanType.Business,
        description: "premium_plan.".concat(types_1.ProductCode.BUSINESS_BASIC, ".description"),
        productCode: types_1.ProductCode.BUSINESS_BASIC,
    },
    678: {
        productFamily: types_1.ProductFamily.Unlimited,
        type: types_1.PlanType.Business,
        description: "premium_plan.".concat(types_1.ProductCode.BUSINESS_UNLIMITED, ".description"),
        productCode: types_1.ProductCode.BUSINESS_UNLIMITED,
    },
    679: {
        productFamily: types_1.ProductFamily.VIP,
        type: types_1.PlanType.Business,
        description: "premium_plan.".concat(types_1.ProductCode.BUSINESS_VIP, ".description"),
        productCode: types_1.ProductCode.BUSINESS_VIP,
    },
    680: {
        productFamily: types_1.ProductFamily.ConnectDomain,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_CONNECT_DOMAIN, ".description"),
        productCode: types_1.ProductCode.WEBSITE_CONNECT_DOMAIN,
        shouldShowAdsNote: true,
    },
    6801: {
        productFamily: types_1.ProductFamily.ConnectDomain,
        type: types_1.PlanType.Website,
        description: 'premium-plan-purchase.plan_description.connect_domain',
        productCode: types_1.ProductCode.WEBSITE_CONNECT_DOMAIN,
        shouldShowAdsNote: true,
    },
    6802: {
        productFamily: types_1.ProductFamily.ConnectDomain,
        type: types_1.PlanType.Website,
        description: 'premium-plan-purchase.plan_description.connect_domain',
        productCode: types_1.ProductCode.WEBSITE_CONNECT_DOMAIN,
        shouldShowAdsNote: true,
    },
    6800: {
        productFamily: types_1.ProductFamily.ConnectDomain,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_CONNECT_DOMAIN, ".description"),
        productCode: types_1.ProductCode.WEBSITE_CONNECT_DOMAIN,
        shouldShowAdsNote: true,
    },
    681: {
        productFamily: types_1.ProductFamily.Combo,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_COMBO, ".description"),
        productCode: types_1.ProductCode.WEBSITE_COMBO,
    },
    6810: {
        productFamily: types_1.ProductFamily.Combo,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_COMBO, ".description"),
        productCode: types_1.ProductCode.WEBSITE_COMBO,
    },
    682: {
        productFamily: types_1.ProductFamily.Unlimited,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_UNLIMITED, ".description"),
        productCode: types_1.ProductCode.WEBSITE_UNLIMITED,
    },
    683: {
        productFamily: types_1.ProductFamily.VIP,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_VIP, ".description"),
        productCode: types_1.ProductCode.WEBSITE_VIP,
    },
    684: {
        productFamily: types_1.ProductFamily.Default,
        type: types_1.PlanType.Business,
        description: "premium_plan.".concat(types_1.ProductCode.BUSINESS_BASIC, ".description"),
        productCode: types_1.ProductCode.BUSINESS_BASIC,
    },
    685: {
        productFamily: types_1.ProductFamily.Unlimited,
        type: types_1.PlanType.Business,
        description: "premium_plan.".concat(types_1.ProductCode.BUSINESS_UNLIMITED, ".description"),
        productCode: types_1.ProductCode.BUSINESS_UNLIMITED,
    },
    686: {
        productFamily: types_1.ProductFamily.VIP,
        type: types_1.PlanType.Business,
        description: "premium_plan.".concat(types_1.ProductCode.BUSINESS_VIP, ".description"),
        productCode: types_1.ProductCode.BUSINESS_VIP,
    },
    688: {
        productFamily: types_1.ProductFamily.ConnectDomain,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_CONNECT_DOMAIN, ".description"),
        productCode: types_1.ProductCode.WEBSITE_CONNECT_DOMAIN,
        shouldShowAdsNote: true,
    },
    689: {
        productFamily: types_1.ProductFamily.Combo,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_COMBO, ".description"),
        productCode: types_1.ProductCode.WEBSITE_COMBO,
    },
    690: {
        productFamily: types_1.ProductFamily.Unlimited,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_UNLIMITED, ".description"),
        productCode: types_1.ProductCode.WEBSITE_UNLIMITED,
    },
    691: {
        productFamily: types_1.ProductFamily.VIP,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_VIP, ".description"),
        productCode: types_1.ProductCode.WEBSITE_VIP,
    },
    692: {
        productFamily: types_1.ProductFamily.Default,
        type: types_1.PlanType.Business,
        description: "premium_plan.".concat(types_1.ProductCode.BUSINESS_BASIC, ".description"),
        productCode: types_1.ProductCode.BUSINESS_BASIC,
    },
    693: {
        productFamily: types_1.ProductFamily.Unlimited,
        type: types_1.PlanType.Business,
        description: "premium_plan.".concat(types_1.ProductCode.BUSINESS_UNLIMITED, ".description"),
        productCode: types_1.ProductCode.BUSINESS_UNLIMITED,
    },
    694: {
        productFamily: types_1.ProductFamily.VIP,
        type: types_1.PlanType.Business,
        description: "premium_plan.".concat(types_1.ProductCode.BUSINESS_VIP, ".description"),
        productCode: types_1.ProductCode.BUSINESS_VIP,
    },
    695: {
        productFamily: types_1.ProductFamily.ConnectDomain,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_CONNECT_DOMAIN, ".description"),
        productCode: types_1.ProductCode.WEBSITE_CONNECT_DOMAIN,
        shouldShowAdsNote: true,
    },
    696: {
        productFamily: types_1.ProductFamily.Combo,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_COMBO, ".description"),
        productCode: types_1.ProductCode.WEBSITE_COMBO,
    },
    697: {
        productFamily: types_1.ProductFamily.Unlimited,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_UNLIMITED, ".description"),
        productCode: types_1.ProductCode.WEBSITE_UNLIMITED,
    },
    698: {
        productFamily: types_1.ProductFamily.VIP,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_VIP, ".description"),
        productCode: types_1.ProductCode.WEBSITE_VIP,
    },
    699: {
        productFamily: types_1.ProductFamily.Default,
        type: types_1.PlanType.Business,
        description: "premium_plan.".concat(types_1.ProductCode.BUSINESS_BASIC, ".description"),
        productCode: types_1.ProductCode.BUSINESS_BASIC,
    },
    700: {
        productFamily: types_1.ProductFamily.Unlimited,
        type: types_1.PlanType.Business,
        description: "premium_plan.".concat(types_1.ProductCode.BUSINESS_UNLIMITED, ".description"),
        productCode: types_1.ProductCode.BUSINESS_UNLIMITED,
    },
    701: {
        productFamily: types_1.ProductFamily.VIP,
        type: types_1.PlanType.Business,
        description: "premium_plan.".concat(types_1.ProductCode.BUSINESS_VIP, ".description"),
        productCode: types_1.ProductCode.BUSINESS_VIP,
    },
    702: {
        productFamily: types_1.ProductFamily.Combo,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_COMBO, ".description"),
        productCode: types_1.ProductCode.WEBSITE_COMBO,
        isAscendBundle: true,
    },
    703: {
        productFamily: types_1.ProductFamily.Unlimited,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_UNLIMITED, ".description"),
        productCode: types_1.ProductCode.WEBSITE_UNLIMITED,
        isAscendBundle: true,
    },
    704: {
        productFamily: types_1.ProductFamily.Pro,
        hatKey: 'product.best_value',
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_PRO, ".description"),
        productCode: types_1.ProductCode.WEBSITE_PRO,
        isAscendBundle: true,
    },
    705: {
        productFamily: types_1.ProductFamily.VIP,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_VIP, ".description"),
        productCode: types_1.ProductCode.WEBSITE_VIP,
        isAscendBundle: true,
    },
    706: {
        productFamily: types_1.ProductFamily.Default,
        type: types_1.PlanType.Business,
        description: "premium_plan.".concat(types_1.ProductCode.BUSINESS_BASIC, ".description"),
        productCode: types_1.ProductCode.BUSINESS_BASIC,
        isAscendBundle: true,
    },
    707: {
        productFamily: types_1.ProductFamily.Unlimited,
        type: types_1.PlanType.Business,
        description: "premium_plan.".concat(types_1.ProductCode.BUSINESS_UNLIMITED, ".description"),
        productCode: types_1.ProductCode.BUSINESS_UNLIMITED,
        isAscendBundle: true,
    },
    708: {
        productFamily: types_1.ProductFamily.VIP,
        type: types_1.PlanType.Business,
        description: "premium_plan.".concat(types_1.ProductCode.BUSINESS_VIP, ".description"),
        productCode: types_1.ProductCode.BUSINESS_VIP,
        isAscendBundle: true,
    },
    709: {
        productFamily: types_1.ProductFamily.Combo,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_COMBO, ".description"),
        productCode: types_1.ProductCode.WEBSITE_COMBO,
    },
    710: {
        productFamily: types_1.ProductFamily.Unlimited,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_UNLIMITED, ".description"),
        productCode: types_1.ProductCode.WEBSITE_UNLIMITED,
    },
    711: {
        productFamily: types_1.ProductFamily.Pro,
        hatKey: 'product.best_value',
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_PRO, ".description"),
        productCode: types_1.ProductCode.WEBSITE_PRO,
    },
    712: {
        productFamily: types_1.ProductFamily.VIP,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_VIP, ".description"),
        productCode: types_1.ProductCode.WEBSITE_VIP,
    },
    713: {
        productFamily: types_1.ProductFamily.Default,
        type: types_1.PlanType.Business,
        description: "premium_plan.".concat(types_1.ProductCode.BUSINESS_BASIC, ".description"),
        productCode: types_1.ProductCode.BUSINESS_BASIC,
    },
    714: {
        productFamily: types_1.ProductFamily.Unlimited,
        type: types_1.PlanType.Business,
        description: "premium_plan.".concat(types_1.ProductCode.BUSINESS_UNLIMITED, ".description"),
        productCode: types_1.ProductCode.BUSINESS_UNLIMITED,
    },
    715: {
        productFamily: types_1.ProductFamily.VIP,
        type: types_1.PlanType.Business,
        description: "premium_plan.".concat(types_1.ProductCode.BUSINESS_VIP, ".description"),
        productCode: types_1.ProductCode.BUSINESS_VIP,
    },
    716: {
        productFamily: types_1.ProductFamily.Unlimited,
        type: types_1.PlanType.Business,
        description: "premium_plan.".concat(types_1.ProductCode.BUSINESS_UNLIMITED, ".description"),
        productCode: types_1.ProductCode.BUSINESS_UNLIMITED,
    },
    717: {
        productFamily: types_1.ProductFamily.Lite,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_CONNECT_DOMAIN, ".description"),
        productCode: types_1.ProductCode.WEBSITE_LITE,
        shouldShowAdsNote: true,
    },
    718: {
        productFamily: types_1.ProductFamily.Lite,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_CONNECT_DOMAIN, ".description"),
        productCode: types_1.ProductCode.WEBSITE_LITE,
        shouldShowAdsNote: true,
    },
    719: {
        productFamily: types_1.ProductFamily.Lite,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_CONNECT_DOMAIN, ".description"),
        productCode: types_1.ProductCode.WEBSITE_LITE,
        shouldShowAdsNote: true,
    },
    720: {
        productFamily: types_1.ProductFamily.Lite,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_CONNECT_DOMAIN, ".description"),
        productCode: types_1.ProductCode.WEBSITE_LITE,
        shouldShowAdsNote: true,
    },
    721: {
        productFamily: types_1.ProductFamily.Lite,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_CONNECT_DOMAIN, ".description"),
        productCode: types_1.ProductCode.WEBSITE_LITE,
        shouldShowAdsNote: true,
    },
    722: {
        productFamily: types_1.ProductFamily.Lite,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_CONNECT_DOMAIN, ".description"),
        productCode: types_1.ProductCode.WEBSITE_LITE,
        shouldShowAdsNote: true,
    },
    723: {
        productFamily: types_1.ProductFamily.Combo,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_COMBO, ".description"),
        productCode: types_1.ProductCode.WEBSITE_COMBO,
    },
    724: {
        productFamily: types_1.ProductFamily.Unlimited,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_UNLIMITED, ".description"),
        productCode: types_1.ProductCode.WEBSITE_UNLIMITED,
    },
    725: {
        productFamily: types_1.ProductFamily.Pro,
        hatKey: 'product.best_value',
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_PRO, ".description"),
        productCode: types_1.ProductCode.WEBSITE_PRO,
    },
    726: {
        productFamily: types_1.ProductFamily.Default,
        type: types_1.PlanType.Business,
        description: "premium_plan.".concat(types_1.ProductCode.BUSINESS_BASIC, ".description"),
        productCode: types_1.ProductCode.BUSINESS_BASIC,
    },
    727: {
        productFamily: types_1.ProductFamily.Unlimited,
        type: types_1.PlanType.Business,
        description: "premium_plan.".concat(types_1.ProductCode.BUSINESS_UNLIMITED, ".description"),
        productCode: types_1.ProductCode.BUSINESS_UNLIMITED,
    },
    728: {
        productFamily: types_1.ProductFamily.Unlimited,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_UNLIMITED, ".description"),
        productCode: types_1.ProductCode.WEBSITE_UNLIMITED,
    },
    729: {
        productFamily: types_1.ProductFamily.VIP,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_VIP, ".description"),
        productCode: types_1.ProductCode.WEBSITE_VIP,
    },
    730: {
        productFamily: types_1.ProductFamily.Unlimited,
        type: types_1.PlanType.Business,
        description: "premium_plan.".concat(types_1.ProductCode.BUSINESS_UNLIMITED, ".description"),
        productCode: types_1.ProductCode.BUSINESS_UNLIMITED,
    },
    731: {
        productFamily: types_1.ProductFamily.ConnectDomain,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_CONNECT_DOMAIN, ".description"),
        productCode: types_1.ProductCode.WEBSITE_CONNECT_DOMAIN,
        shouldShowAdsNote: true,
    },
    732: {
        productFamily: types_1.ProductFamily.Combo,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_COMBO, ".description"),
        productCode: types_1.ProductCode.WEBSITE_COMBO,
    },
    733: {
        productFamily: types_1.ProductFamily.Unlimited,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_UNLIMITED, ".description"),
        productCode: types_1.ProductCode.WEBSITE_UNLIMITED,
    },
    734: {
        productFamily: types_1.ProductFamily.Unlimited,
        type: types_1.PlanType.Business,
        description: "premium_plan.".concat(types_1.ProductCode.BUSINESS_UNLIMITED, ".description"),
        productCode: types_1.ProductCode.BUSINESS_UNLIMITED,
    },
    735: {
        productFamily: types_1.ProductFamily.VIP,
        type: types_1.PlanType.Business,
        description: "premium_plan.".concat(types_1.ProductCode.BUSINESS_VIP, ".description"),
        productCode: types_1.ProductCode.BUSINESS_VIP,
    },
    736: {
        productFamily: types_1.ProductFamily.ConnectDomain,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_CONNECT_DOMAIN, ".description"),
        productCode: types_1.ProductCode.WEBSITE_CONNECT_DOMAIN,
        shouldShowAdsNote: true,
    },
    737: {
        productFamily: types_1.ProductFamily.Combo,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_COMBO, ".description"),
        productCode: types_1.ProductCode.WEBSITE_COMBO,
    },
    738: {
        productFamily: types_1.ProductFamily.Unlimited,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_UNLIMITED, ".description"),
        productCode: types_1.ProductCode.WEBSITE_UNLIMITED,
    },
    739: {
        productFamily: types_1.ProductFamily.VIP,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_VIP, ".description"),
        productCode: types_1.ProductCode.WEBSITE_VIP,
    },
    740: {
        productFamily: types_1.ProductFamily.Unlimited,
        type: types_1.PlanType.Business,
        description: "premium_plan.".concat(types_1.ProductCode.BUSINESS_UNLIMITED, ".description"),
        productCode: types_1.ProductCode.BUSINESS_UNLIMITED,
    },
    741: {
        productFamily: types_1.ProductFamily.Combo,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_COMBO, ".description"),
        productCode: types_1.ProductCode.WEBSITE_COMBO,
    },
    742: {
        productFamily: types_1.ProductFamily.Unlimited,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_UNLIMITED, ".description"),
        productCode: types_1.ProductCode.WEBSITE_UNLIMITED,
    },
    743: {
        productFamily: types_1.ProductFamily.Pro,
        hatKey: 'product.best_value',
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_PRO, ".description"),
        productCode: types_1.ProductCode.WEBSITE_PRO,
    },
    744: {
        productFamily: types_1.ProductFamily.Default,
        type: types_1.PlanType.Business,
        description: "premium_plan.".concat(types_1.ProductCode.BUSINESS_BASIC, ".description"),
        productCode: types_1.ProductCode.BUSINESS_BASIC,
    },
    745: {
        productFamily: types_1.ProductFamily.Unlimited,
        type: types_1.PlanType.Business,
        description: "premium_plan.".concat(types_1.ProductCode.BUSINESS_UNLIMITED, ".description"),
        productCode: types_1.ProductCode.BUSINESS_UNLIMITED,
    },
    746: {
        productFamily: types_1.ProductFamily.Combo,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_COMBO, ".description"),
        productCode: types_1.ProductCode.WEBSITE_COMBO,
    },
    747: {
        productFamily: types_1.ProductFamily.Unlimited,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_UNLIMITED, ".description"),
        productCode: types_1.ProductCode.WEBSITE_UNLIMITED,
    },
    748: {
        productFamily: types_1.ProductFamily.VIP,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_VIP, ".description"),
        productCode: types_1.ProductCode.WEBSITE_VIP,
    },
    749: {
        productFamily: types_1.ProductFamily.Default,
        type: types_1.PlanType.Business,
        description: "premium_plan.".concat(types_1.ProductCode.BUSINESS_BASIC, ".description"),
        productCode: types_1.ProductCode.BUSINESS_BASIC,
    },
    750: {
        productFamily: types_1.ProductFamily.Unlimited,
        type: types_1.PlanType.Business,
        description: "premium_plan.".concat(types_1.ProductCode.BUSINESS_UNLIMITED, ".description"),
        productCode: types_1.ProductCode.BUSINESS_UNLIMITED,
    },
    751: {
        productFamily: types_1.ProductFamily.VIP,
        type: types_1.PlanType.Business,
        description: "premium_plan.".concat(types_1.ProductCode.BUSINESS_VIP, ".description"),
        productCode: types_1.ProductCode.BUSINESS_VIP,
    },
    760: {
        productFamily: types_1.ProductFamily.Combo,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_COMBO, ".description"),
        productCode: types_1.ProductCode.WEBSITE_COMBO,
    },
    1010: {
        productFamily: types_1.ProductFamily.Combo,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_COMBO, ".description"),
        productCode: types_1.ProductCode.WEBSITE_COMBO,
    },
    761: {
        productFamily: types_1.ProductFamily.Unlimited,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_UNLIMITED, ".description"),
        productCode: types_1.ProductCode.WEBSITE_UNLIMITED,
    },
    762: {
        productFamily: types_1.ProductFamily.Pro,
        hatKey: 'product.best_value',
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_PRO, ".description"),
        productCode: types_1.ProductCode.WEBSITE_PRO,
    },
    763: {
        productFamily: types_1.ProductFamily.VIP,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_VIP, ".description"),
        productCode: types_1.ProductCode.WEBSITE_VIP,
    },
    764: {
        productFamily: types_1.ProductFamily.Default,
        type: types_1.PlanType.Business,
        description: "premium_plan.".concat(types_1.ProductCode.BUSINESS_BASIC, ".description"),
        productCode: types_1.ProductCode.BUSINESS_BASIC,
    },
    765: {
        productFamily: types_1.ProductFamily.Unlimited,
        type: types_1.PlanType.Business,
        description: "premium_plan.".concat(types_1.ProductCode.BUSINESS_UNLIMITED, ".description"),
        productCode: types_1.ProductCode.BUSINESS_UNLIMITED,
    },
    766: {
        productFamily: types_1.ProductFamily.VIP,
        type: types_1.PlanType.Business,
        description: "premium_plan.".concat(types_1.ProductCode.BUSINESS_VIP, ".description"),
        productCode: types_1.ProductCode.BUSINESS_VIP,
    },
    1011: {
        productFamily: types_1.ProductFamily.VIP,
        type: types_1.PlanType.Business,
        description: "premium_plan.".concat(types_1.ProductCode.BUSINESS_VIP, ".description"),
        productCode: types_1.ProductCode.BUSINESS_VIP,
    },
    752: {
        productFamily: types_1.ProductFamily.Unlimited,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_UNLIMITED, ".description"),
        productCode: types_1.ProductCode.WEBSITE_UNLIMITED,
    },
    754: {
        productFamily: types_1.ProductFamily.VIP,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_VIP, ".description"),
        productCode: types_1.ProductCode.WEBSITE_VIP,
    },
    755: {
        productFamily: types_1.ProductFamily.Unlimited,
        type: types_1.PlanType.Business,
        description: "premium_plan.".concat(types_1.ProductCode.BUSINESS_UNLIMITED, ".description"),
        productCode: types_1.ProductCode.BUSINESS_UNLIMITED,
    },
    756: {
        productFamily: types_1.ProductFamily.VIP,
        type: types_1.PlanType.Business,
        description: "premium_plan.".concat(types_1.ProductCode.BUSINESS_VIP, ".description"),
        productCode: types_1.ProductCode.BUSINESS_VIP,
    },
    767: {
        productFamily: types_1.ProductFamily.Unlimited,
        type: types_1.PlanType.Business,
        description: "premium_plan.".concat(types_1.ProductCode.BUSINESS_UNLIMITED, ".description"),
        productCode: types_1.ProductCode.BUSINESS_UNLIMITED,
    },
    768: {
        productFamily: types_1.ProductFamily.VIP,
        type: types_1.PlanType.Business,
        description: "premium_plan.".concat(types_1.ProductCode.BUSINESS_VIP, ".description"),
        productCode: types_1.ProductCode.BUSINESS_VIP,
    },
    757: {
        productFamily: types_1.ProductFamily.Combo,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_COMBO, ".description"),
        productCode: types_1.ProductCode.WEBSITE_COMBO,
    },
    758: {
        productFamily: types_1.ProductFamily.Unlimited,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_UNLIMITED, ".description"),
        productCode: types_1.ProductCode.WEBSITE_UNLIMITED,
    },
    759: {
        productFamily: types_1.ProductFamily.Default,
        type: types_1.PlanType.Business,
        description: "premium_plan.".concat(types_1.ProductCode.BUSINESS_BASIC, ".description"),
        productCode: types_1.ProductCode.BUSINESS_BASIC,
    },
    769: {
        productFamily: types_1.ProductFamily.VIP,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_VIP, ".description"),
        productCode: types_1.ProductCode.WEBSITE_VIP,
    },
    770: {
        productFamily: types_1.ProductFamily.Combo,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_COMBO, ".description"),
        productCode: types_1.ProductCode.WEBSITE_COMBO,
    },
    7700: {
        productFamily: types_1.ProductFamily.Combo,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_COMBO, ".description"),
        productCode: types_1.ProductCode.WEBSITE_COMBO,
    },
    7701: {
        productFamily: types_1.ProductFamily.Combo,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_COMBO, ".description"),
        productCode: types_1.ProductCode.WEBSITE_COMBO,
    },
    771: {
        productFamily: types_1.ProductFamily.Unlimited,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_UNLIMITED, ".description"),
        productCode: types_1.ProductCode.WEBSITE_UNLIMITED,
    },
    772: {
        productFamily: types_1.ProductFamily.Pro,
        hatKey: 'product.best_value',
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_PRO, ".description"),
        productCode: types_1.ProductCode.WEBSITE_PRO,
    },
    773: {
        productFamily: types_1.ProductFamily.VIP,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_VIP, ".description"),
        productCode: types_1.ProductCode.WEBSITE_VIP,
    },
    774: {
        productFamily: types_1.ProductFamily.Default,
        type: types_1.PlanType.Business,
        description: "premium_plan.".concat(types_1.ProductCode.BUSINESS_BASIC, ".description"),
        productCode: types_1.ProductCode.BUSINESS_BASIC,
    },
    820: {
        productFamily: types_1.ProductFamily.Default,
        type: types_1.PlanType.Business,
        description: "premium_plan.".concat(types_1.ProductCode.BUSINESS_BASIC, ".description"),
        productCode: types_1.ProductCode.BUSINESS_BASIC,
    },
    821: {
        productFamily: types_1.ProductFamily.Default,
        type: types_1.PlanType.Business,
        description: "premium_plan.".concat(types_1.ProductCode.BUSINESS_BASIC, ".description"),
        productCode: types_1.ProductCode.BUSINESS_BASIC,
    },
    775: {
        productFamily: types_1.ProductFamily.Unlimited,
        type: types_1.PlanType.Business,
        description: "premium_plan.".concat(types_1.ProductCode.BUSINESS_UNLIMITED, ".description"),
        productCode: types_1.ProductCode.BUSINESS_UNLIMITED,
    },
    776: {
        productFamily: types_1.ProductFamily.VIP,
        type: types_1.PlanType.Business,
        description: "premium_plan.".concat(types_1.ProductCode.BUSINESS_VIP, ".description"),
        productCode: types_1.ProductCode.BUSINESS_VIP,
    },
    777: {
        productFamily: types_1.ProductFamily.ConnectDomain,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_CONNECT_DOMAIN, ".description"),
        productCode: types_1.ProductCode.WEBSITE_CONNECT_DOMAIN,
        shouldShowAdsNote: true,
    },
    7770: {
        productFamily: types_1.ProductFamily.ConnectDomain,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_CONNECT_DOMAIN, ".description"),
        productCode: types_1.ProductCode.WEBSITE_CONNECT_DOMAIN,
        shouldShowAdsNote: true,
    },
    778: {
        productFamily: types_1.ProductFamily.Combo,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_COMBO, ".description"),
        productCode: types_1.ProductCode.WEBSITE_COMBO,
    },
    7780: {
        productFamily: types_1.ProductFamily.Combo,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_COMBO, ".description"),
        productCode: types_1.ProductCode.WEBSITE_COMBO,
    },
    779: {
        productFamily: types_1.ProductFamily.Unlimited,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_UNLIMITED, ".description"),
        productCode: types_1.ProductCode.WEBSITE_UNLIMITED,
    },
    781: {
        productFamily: types_1.ProductFamily.VIP,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_VIP, ".description"),
        productCode: types_1.ProductCode.WEBSITE_VIP,
    },
    782: {
        productFamily: types_1.ProductFamily.Default,
        type: types_1.PlanType.Business,
        description: "premium_plan.".concat(types_1.ProductCode.BUSINESS_BASIC, ".description"),
        productCode: types_1.ProductCode.BUSINESS_BASIC,
    },
    783: {
        productFamily: types_1.ProductFamily.Unlimited,
        type: types_1.PlanType.Business,
        description: "premium_plan.".concat(types_1.ProductCode.BUSINESS_UNLIMITED, ".description"),
        productCode: types_1.ProductCode.BUSINESS_UNLIMITED,
    },
    784: {
        productFamily: types_1.ProductFamily.VIP,
        type: types_1.PlanType.Business,
        description: "premium_plan.".concat(types_1.ProductCode.BUSINESS_VIP, ".description"),
        productCode: types_1.ProductCode.BUSINESS_VIP,
    },
    785: {
        productFamily: types_1.ProductFamily.ConnectDomain,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_CONNECT_DOMAIN, ".description"),
        productCode: types_1.ProductCode.WEBSITE_CONNECT_DOMAIN,
        shouldShowAdsNote: true,
    },
    7850: {
        productFamily: types_1.ProductFamily.ConnectDomain,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_CONNECT_DOMAIN, ".description"),
        productCode: types_1.ProductCode.WEBSITE_CONNECT_DOMAIN,
        shouldShowAdsNote: true,
    },
    786: {
        productFamily: types_1.ProductFamily.Combo,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_COMBO, ".description"),
        productCode: types_1.ProductCode.WEBSITE_COMBO,
    },
    7860: {
        productFamily: types_1.ProductFamily.Combo,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_COMBO, ".description"),
        productCode: types_1.ProductCode.WEBSITE_COMBO,
    },
    787: {
        productFamily: types_1.ProductFamily.Unlimited,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_UNLIMITED, ".description"),
        productCode: types_1.ProductCode.WEBSITE_UNLIMITED,
    },
    788: {
        productFamily: types_1.ProductFamily.VIP,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_VIP, ".description"),
        productCode: types_1.ProductCode.WEBSITE_VIP,
    },
    789: {
        productFamily: types_1.ProductFamily.Default,
        type: types_1.PlanType.Business,
        description: "premium_plan.".concat(types_1.ProductCode.BUSINESS_BASIC, ".description"),
        productCode: types_1.ProductCode.BUSINESS_BASIC,
    },
    790: {
        productFamily: types_1.ProductFamily.Unlimited,
        type: types_1.PlanType.Business,
        description: "premium_plan.".concat(types_1.ProductCode.BUSINESS_UNLIMITED, ".description"),
        productCode: types_1.ProductCode.BUSINESS_UNLIMITED,
    },
    791: {
        productFamily: types_1.ProductFamily.VIP,
        type: types_1.PlanType.Business,
        description: "premium_plan.".concat(types_1.ProductCode.BUSINESS_VIP, ".description"),
        productCode: types_1.ProductCode.BUSINESS_VIP,
    },
    792: {
        productFamily: types_1.ProductFamily.Combo,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_COMBO, ".description"),
        productCode: types_1.ProductCode.WEBSITE_COMBO,
    },
    7920: {
        productFamily: types_1.ProductFamily.Combo,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_COMBO, ".description"),
        productCode: types_1.ProductCode.WEBSITE_COMBO,
    },
    793: {
        productFamily: types_1.ProductFamily.Unlimited,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_UNLIMITED, ".description"),
        productCode: types_1.ProductCode.WEBSITE_UNLIMITED,
    },
    794: {
        productFamily: types_1.ProductFamily.Pro,
        hatKey: 'product.best_value',
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_PRO, ".description"),
        productCode: types_1.ProductCode.WEBSITE_PRO,
    },
    796: {
        productFamily: types_1.ProductFamily.VIP,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_VIP, ".description"),
        productCode: types_1.ProductCode.WEBSITE_VIP,
    },
    797: {
        productFamily: types_1.ProductFamily.Default,
        type: types_1.PlanType.Business,
        description: "premium_plan.".concat(types_1.ProductCode.BUSINESS_BASIC, ".description"),
        productCode: types_1.ProductCode.BUSINESS_BASIC,
    },
    798: {
        productFamily: types_1.ProductFamily.Unlimited,
        type: types_1.PlanType.Business,
        description: "premium_plan.".concat(types_1.ProductCode.BUSINESS_UNLIMITED, ".description"),
        productCode: types_1.ProductCode.BUSINESS_UNLIMITED,
    },
    799: {
        productFamily: types_1.ProductFamily.VIP,
        type: types_1.PlanType.Business,
        description: "premium_plan.".concat(types_1.ProductCode.BUSINESS_VIP, ".description"),
        productCode: types_1.ProductCode.BUSINESS_VIP,
    },
    800: {
        productFamily: types_1.ProductFamily.ConnectDomain,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_CONNECT_DOMAIN, ".description"),
        productCode: types_1.ProductCode.WEBSITE_CONNECT_DOMAIN,
        shouldShowAdsNote: true,
    },
    8000: {
        productFamily: types_1.ProductFamily.ConnectDomain,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_CONNECT_DOMAIN, ".description"),
        productCode: types_1.ProductCode.WEBSITE_CONNECT_DOMAIN,
        shouldShowAdsNote: true,
    },
    801: {
        productFamily: types_1.ProductFamily.Combo,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_COMBO, ".description"),
        productCode: types_1.ProductCode.WEBSITE_COMBO,
    },
    8010: {
        productFamily: types_1.ProductFamily.Combo,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_COMBO, ".description"),
        productCode: types_1.ProductCode.WEBSITE_COMBO,
    },
    803: {
        productFamily: types_1.ProductFamily.Unlimited,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_UNLIMITED, ".description"),
        productCode: types_1.ProductCode.WEBSITE_UNLIMITED,
    },
    805: {
        productFamily: types_1.ProductFamily.VIP,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_VIP, ".description"),
        productCode: types_1.ProductCode.WEBSITE_VIP,
    },
    806: {
        productFamily: types_1.ProductFamily.Default,
        type: types_1.PlanType.Business,
        description: "premium_plan.".concat(types_1.ProductCode.BUSINESS_BASIC, ".description"),
        productCode: types_1.ProductCode.BUSINESS_BASIC,
    },
    807: {
        productFamily: types_1.ProductFamily.Unlimited,
        type: types_1.PlanType.Business,
        description: "premium_plan.".concat(types_1.ProductCode.BUSINESS_UNLIMITED, ".description"),
        productCode: types_1.ProductCode.BUSINESS_UNLIMITED,
    },
    808: {
        productFamily: types_1.ProductFamily.VIP,
        type: types_1.PlanType.Business,
        description: "premium_plan.".concat(types_1.ProductCode.BUSINESS_VIP, ".description"),
        productCode: types_1.ProductCode.BUSINESS_VIP,
    },
    809: {
        productFamily: types_1.ProductFamily.Combo,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_COMBO, ".description"),
        productCode: types_1.ProductCode.WEBSITE_COMBO,
    },
    810: {
        productFamily: types_1.ProductFamily.ConnectDomain,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_CONNECT_DOMAIN, ".description"),
        productCode: types_1.ProductCode.WEBSITE_CONNECT_DOMAIN,
        shouldShowAdsNote: true,
    },
    8100: {
        productFamily: types_1.ProductFamily.ConnectDomain,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_CONNECT_DOMAIN, ".description"),
        productCode: types_1.ProductCode.WEBSITE_CONNECT_DOMAIN,
        shouldShowAdsNote: true,
    },
    811: {
        productFamily: types_1.ProductFamily.Combo,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_COMBO, ".description"),
        productCode: types_1.ProductCode.WEBSITE_COMBO,
    },
    8110: {
        productFamily: types_1.ProductFamily.Combo,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_COMBO, ".description"),
        productCode: types_1.ProductCode.WEBSITE_COMBO,
    },
    812: {
        productFamily: types_1.ProductFamily.Unlimited,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_UNLIMITED, ".description"),
        productCode: types_1.ProductCode.WEBSITE_UNLIMITED,
    },
    813: {
        productFamily: types_1.ProductFamily.VIP,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_VIP, ".description"),
        productCode: types_1.ProductCode.WEBSITE_VIP,
    },
    814: {
        productFamily: types_1.ProductFamily.Default,
        type: types_1.PlanType.Business,
        description: "premium_plan.".concat(types_1.ProductCode.BUSINESS_BASIC, ".description"),
        productCode: types_1.ProductCode.BUSINESS_BASIC,
    },
    815: {
        productFamily: types_1.ProductFamily.Unlimited,
        type: types_1.PlanType.Business,
        description: "premium_plan.".concat(types_1.ProductCode.BUSINESS_UNLIMITED, ".description"),
        productCode: types_1.ProductCode.BUSINESS_UNLIMITED,
    },
    816: {
        productFamily: types_1.ProductFamily.VIP,
        type: types_1.PlanType.Business,
        description: "premium_plan.".concat(types_1.ProductCode.BUSINESS_VIP, ".description"),
        productCode: types_1.ProductCode.BUSINESS_VIP,
    },
    900: {
        productFamily: types_1.ProductFamily.Combo,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_COMBO, ".new_description"),
        productCode: types_1.ProductCode.WEBSITE_COMBO,
    },
    901: {
        productFamily: types_1.ProductFamily.Unlimited,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_UNLIMITED, ".new_description"),
        productCode: types_1.ProductCode.WEBSITE_UNLIMITED,
    },
    902: {
        productFamily: types_1.ProductFamily.Pro,
        hatKey: 'product.best_value',
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_PRO, ".new_description"),
        productCode: types_1.ProductCode.WEBSITE_PRO,
    },
    903: {
        productFamily: types_1.ProductFamily.VIP,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_VIP, ".new_description"),
        productCode: types_1.ProductCode.WEBSITE_VIP,
    },
    904: {
        productFamily: types_1.ProductFamily.Default,
        type: types_1.PlanType.Business,
        description: "premium_plan.".concat(types_1.ProductCode.BUSINESS_BASIC, ".new_description"),
        productCode: types_1.ProductCode.BUSINESS_BASIC,
    },
    905: {
        productFamily: types_1.ProductFamily.Unlimited,
        type: types_1.PlanType.Business,
        description: "premium_plan.".concat(types_1.ProductCode.BUSINESS_UNLIMITED, ".new_description"),
        productCode: types_1.ProductCode.BUSINESS_UNLIMITED,
    },
    906: {
        productFamily: types_1.ProductFamily.VIP,
        type: types_1.PlanType.Business,
        description: "premium_plan.".concat(types_1.ProductCode.BUSINESS_VIP, ".new_description"),
        productCode: types_1.ProductCode.BUSINESS_VIP,
    },
    910: {
        productFamily: types_1.ProductFamily.Combo,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_COMBO, ".new_description"),
        productCode: types_1.ProductCode.WEBSITE_COMBO,
    },
    911: {
        productFamily: types_1.ProductFamily.Unlimited,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_UNLIMITED, ".new_description"),
        productCode: types_1.ProductCode.WEBSITE_UNLIMITED,
    },
    912: {
        productFamily: types_1.ProductFamily.Pro,
        hatKey: 'product.best_value',
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_PRO, ".new_description"),
        productCode: types_1.ProductCode.WEBSITE_PRO,
    },
    913: {
        productFamily: types_1.ProductFamily.VIP,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_VIP, ".new_description"),
        productCode: types_1.ProductCode.WEBSITE_VIP,
    },
    914: {
        productFamily: types_1.ProductFamily.Default,
        type: types_1.PlanType.Business,
        description: "premium_plan.".concat(types_1.ProductCode.BUSINESS_BASIC, ".new_description"),
        productCode: types_1.ProductCode.BUSINESS_BASIC,
    },
    915: {
        productFamily: types_1.ProductFamily.Unlimited,
        type: types_1.PlanType.Business,
        description: "premium_plan.".concat(types_1.ProductCode.BUSINESS_UNLIMITED, ".new_description"),
        productCode: types_1.ProductCode.BUSINESS_UNLIMITED,
    },
    916: {
        productFamily: types_1.ProductFamily.VIP,
        type: types_1.PlanType.Business,
        description: "premium_plan.".concat(types_1.ProductCode.BUSINESS_VIP, ".new_description"),
        productCode: types_1.ProductCode.BUSINESS_VIP,
    },
    917: {
        productFamily: types_1.ProductFamily.Unlimited,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_UNLIMITED, ".new_description"),
        productCode: types_1.ProductCode.WEBSITE_UNLIMITED,
    },
    918: {
        productFamily: types_1.ProductFamily.Unlimited,
        type: types_1.PlanType.Business,
        description: "premium_plan.".concat(types_1.ProductCode.BUSINESS_UNLIMITED, ".new_description"),
        productCode: types_1.ProductCode.BUSINESS_UNLIMITED,
    },
    924: {
        productFamily: types_1.ProductFamily.Default,
        type: types_1.PlanType.Business,
        description: "premium_plan.".concat(types_1.ProductCode.BUSINESS_BASIC, ".new_description"),
        productCode: types_1.ProductCode.BUSINESS_BASIC,
    },
    925: {
        productFamily: types_1.ProductFamily.Unlimited,
        type: types_1.PlanType.Business,
        description: "premium_plan.".concat(types_1.ProductCode.BUSINESS_UNLIMITED, ".new_description"),
        productCode: types_1.ProductCode.BUSINESS_UNLIMITED,
    },
    926: {
        productFamily: types_1.ProductFamily.VIP,
        type: types_1.PlanType.Business,
        description: "premium_plan.".concat(types_1.ProductCode.BUSINESS_VIP, ".new_description"),
        productCode: types_1.ProductCode.BUSINESS_VIP,
    },
    927: {
        productFamily: types_1.ProductFamily.Default,
        type: types_1.PlanType.Business,
        description: "premium_plan.".concat(types_1.ProductCode.BUSINESS_BASIC, ".new_description"),
        productCode: types_1.ProductCode.BUSINESS_BASIC,
    },
    928: {
        productFamily: types_1.ProductFamily.Unlimited,
        type: types_1.PlanType.Business,
        description: "premium_plan.".concat(types_1.ProductCode.BUSINESS_UNLIMITED, ".new_description"),
        productCode: types_1.ProductCode.BUSINESS_UNLIMITED,
    },
    929: {
        productFamily: types_1.ProductFamily.VIP,
        type: types_1.PlanType.Business,
        description: "premium_plan.".concat(types_1.ProductCode.BUSINESS_VIP, ".new_description"),
        productCode: types_1.ProductCode.BUSINESS_VIP,
    },
    930: {
        productFamily: types_1.ProductFamily.Light,
        description: 'premium_plan.product.description.light',
        productCode: types_1.ProductCode.LIGHT,
        type: types_1.PlanType.Business,
    },
    9301: {
        productFamily: types_1.ProductFamily.Light,
        description: 'premium_plan.product.description.light',
        productCode: types_1.ProductCode.LIGHT,
        type: types_1.PlanType.Business,
    },
    2218: {
        productFamily: types_1.ProductFamily.Light,
        description: 'premium_plan.product.description.light',
        productCode: types_1.ProductCode.LIGHT,
        type: types_1.PlanType.Business,
    },
    9302: {
        productFamily: types_1.ProductFamily.Light,
        description: 'premium_plan.product.description.light',
        productCode: types_1.ProductCode.LIGHT,
        type: types_1.PlanType.Business,
    },
    2221: {
        productFamily: types_1.ProductFamily.Light,
        description: 'premium_plan.product.description.light',
        productCode: types_1.ProductCode.LIGHT,
        type: types_1.PlanType.Business,
    },
    9303: {
        productFamily: types_1.ProductFamily.Light,
        description: 'premium_plan.product.description.light',
        productCode: types_1.ProductCode.LIGHT,
        type: types_1.PlanType.Business,
    },
    2220: {
        productFamily: types_1.ProductFamily.Light,
        description: 'premium_plan.product.description.light',
        productCode: types_1.ProductCode.LIGHT,
        type: types_1.PlanType.Business,
    },
    9304: {
        productFamily: types_1.ProductFamily.Light,
        description: 'premium_plan.product.description.light',
        productCode: types_1.ProductCode.LIGHT,
        type: types_1.PlanType.Business,
    },
    2219: {
        productFamily: types_1.ProductFamily.Light,
        description: 'premium_plan.product.description.light',
        productCode: types_1.ProductCode.LIGHT,
        type: types_1.PlanType.Business,
    },
    9305: {
        productFamily: types_1.ProductFamily.Light,
        description: 'premium_plan.product.description.light',
        productCode: types_1.ProductCode.LIGHT,
        type: types_1.PlanType.Business,
    },
    2225: {
        productFamily: types_1.ProductFamily.Light,
        description: 'premium_plan.product.description.light',
        productCode: types_1.ProductCode.LIGHT,
        type: types_1.PlanType.Business,
    },
    940: {
        productFamily: types_1.ProductFamily.Light,
        description: 'premium_plan.product.description.light',
        productCode: types_1.ProductCode.LIGHT,
        type: types_1.PlanType.Business,
    },
    9401: {
        productFamily: types_1.ProductFamily.Light,
        description: 'premium_plan.product.description.light',
        productCode: types_1.ProductCode.LIGHT,
        type: types_1.PlanType.Business,
    },
    9802: {
        productFamily: types_1.ProductFamily.Light,
        description: 'premium_plan.product.description.light',
        productCode: types_1.ProductCode.LIGHT,
        type: types_1.PlanType.Business,
    },
    9402: {
        productFamily: types_1.ProductFamily.Light,
        description: 'premium_plan.product.description.light',
        productCode: types_1.ProductCode.LIGHT,
        type: types_1.PlanType.Business,
    },
    9803: {
        productFamily: types_1.ProductFamily.Light,
        description: 'premium_plan.product.description.light',
        productCode: types_1.ProductCode.LIGHT,
        type: types_1.PlanType.Business,
    },
    9403: {
        productFamily: types_1.ProductFamily.Light,
        description: 'premium_plan.product.description.light',
        productCode: types_1.ProductCode.LIGHT,
        type: types_1.PlanType.Business,
    },
    9804: {
        productFamily: types_1.ProductFamily.Light,
        description: 'premium_plan.product.description.light',
        productCode: types_1.ProductCode.LIGHT,
        type: types_1.PlanType.Business,
    },
    950: {
        productFamily: types_1.ProductFamily.Light,
        description: 'premium_plan.product.description.light',
        productCode: types_1.ProductCode.LIGHT,
        type: types_1.PlanType.Business,
    },
    9501: {
        productFamily: types_1.ProductFamily.Light,
        description: 'premium_plan.product.description.light',
        productCode: types_1.ProductCode.LIGHT,
        type: types_1.PlanType.Business,
    },
    95010: {
        productFamily: types_1.ProductFamily.Light,
        description: 'premium_plan.product.description.light',
        productCode: types_1.ProductCode.LIGHT,
        type: types_1.PlanType.Business,
    },
    9502: {
        productFamily: types_1.ProductFamily.Light,
        description: 'premium_plan.product.description.light',
        productCode: types_1.ProductCode.LIGHT,
        type: types_1.PlanType.Business,
    },
    95020: {
        productFamily: types_1.ProductFamily.Light,
        description: 'premium_plan.product.description.light',
        productCode: types_1.ProductCode.LIGHT,
        type: types_1.PlanType.Business,
    },
    9503: {
        productFamily: types_1.ProductFamily.Light,
        description: 'premium_plan.product.description.light',
        productCode: types_1.ProductCode.LIGHT,
        type: types_1.PlanType.Business,
    },
    95030: {
        productFamily: types_1.ProductFamily.Light,
        description: 'premium_plan.product.description.light',
        productCode: types_1.ProductCode.LIGHT,
        type: types_1.PlanType.Business,
    },
    980: {
        productFamily: types_1.ProductFamily.Light,
        description: 'premium_plan.product.description.light',
        productCode: types_1.ProductCode.LIGHT,
        type: types_1.PlanType.Business,
    },
    9801: {
        productFamily: types_1.ProductFamily.Light,
        description: 'premium_plan.product.description.light',
        productCode: types_1.ProductCode.LIGHT,
        type: types_1.PlanType.Business,
    },
    2200: {
        productFamily: types_1.ProductFamily.Light,
        description: 'premium_plan.product.description.light',
        productCode: types_1.ProductCode.LIGHT,
        type: types_1.PlanType.Business,
    },
    22001: {
        productFamily: types_1.ProductFamily.Light,
        description: 'premium_plan.product.description.light',
        productCode: types_1.ProductCode.LIGHT,
        type: types_1.PlanType.Business,
    },
    37514: {
        productFamily: types_1.ProductFamily.Light,
        description: 'premium_plan.product.description.light',
        productCode: types_1.ProductCode.LIGHT,
        type: types_1.PlanType.Business,
    },
    37530: {
        productFamily: types_1.ProductFamily.Light,
        description: 'premium_plan.product.description.light',
        productCode: types_1.ProductCode.LIGHT,
        type: types_1.PlanType.Business,
    },
    22002: {
        productFamily: types_1.ProductFamily.Light,
        description: 'premium_plan.product.description.light',
        productCode: types_1.ProductCode.LIGHT,
        type: types_1.PlanType.Business,
    },
    935: {
        productFamily: types_1.ProductFamily.Light,
        description: 'premium_plan.product.description.light',
        productCode: types_1.ProductCode.LIGHT,
        type: types_1.PlanType.Business,
    },
    945: {
        productFamily: types_1.ProductFamily.Light,
        description: 'premium_plan.product.description.light',
        productCode: types_1.ProductCode.LIGHT,
        type: types_1.PlanType.Business,
    },
    955: {
        productFamily: types_1.ProductFamily.Light,
        description: 'premium_plan.product.description.light',
        productCode: types_1.ProductCode.LIGHT,
        type: types_1.PlanType.Business,
    },
    960: {
        productFamily: types_1.ProductFamily.Light,
        description: 'premium_plan.product.description.light',
        productCode: types_1.ProductCode.LIGHT,
        type: types_1.PlanType.Business,
    },
    9601: {
        productFamily: types_1.ProductFamily.Light,
        description: 'premium_plan.product.description.light',
        productCode: types_1.ProductCode.LIGHT,
        type: types_1.PlanType.Business,
    },
    96010: {
        productFamily: types_1.ProductFamily.Light,
        description: 'premium_plan.product.description.light',
        productCode: types_1.ProductCode.LIGHT,
        type: types_1.PlanType.Business,
    },
    9602: {
        productFamily: types_1.ProductFamily.Light,
        description: 'premium_plan.product.description.light',
        productCode: types_1.ProductCode.LIGHT,
        type: types_1.PlanType.Business,
    },
    96020: {
        productFamily: types_1.ProductFamily.Light,
        description: 'premium_plan.product.description.light',
        productCode: types_1.ProductCode.LIGHT,
        type: types_1.PlanType.Business,
    },
    9603: {
        productFamily: types_1.ProductFamily.Light,
        description: 'premium_plan.product.description.light',
        productCode: types_1.ProductCode.LIGHT,
        type: types_1.PlanType.Business,
    },
    96030: {
        productFamily: types_1.ProductFamily.Light,
        description: 'premium_plan.product.description.light',
        productCode: types_1.ProductCode.LIGHT,
        type: types_1.PlanType.Business,
    },
    970: {
        productFamily: types_1.ProductFamily.Light,
        description: 'premium_plan.product.description.light',
        productCode: types_1.ProductCode.LIGHT,
        type: types_1.PlanType.Business,
    },
    9701: {
        productFamily: types_1.ProductFamily.Light,
        description: 'premium_plan.product.description.light',
        productCode: types_1.ProductCode.LIGHT,
        type: types_1.PlanType.Business,
    },
    2222: {
        productFamily: types_1.ProductFamily.Light,
        description: 'premium_plan.product.description.light',
        productCode: types_1.ProductCode.LIGHT,
        type: types_1.PlanType.Business,
    },
    9702: {
        productFamily: types_1.ProductFamily.Light,
        description: 'premium_plan.product.description.light',
        productCode: types_1.ProductCode.LIGHT,
        type: types_1.PlanType.Business,
    },
    2224: {
        productFamily: types_1.ProductFamily.Light,
        description: 'premium_plan.product.description.light',
        productCode: types_1.ProductCode.LIGHT,
        type: types_1.PlanType.Business,
    },
    9703: {
        productFamily: types_1.ProductFamily.Light,
        description: 'premium_plan.product.description.light',
        productCode: types_1.ProductCode.LIGHT,
        type: types_1.PlanType.Business,
    },
    2223: {
        productFamily: types_1.ProductFamily.Light,
        description: 'premium_plan.product.description.light',
        productCode: types_1.ProductCode.LIGHT,
        type: types_1.PlanType.Business,
    },
    9704: {
        productFamily: types_1.ProductFamily.Light,
        description: 'premium_plan.product.description.light',
        productCode: types_1.ProductCode.LIGHT,
        type: types_1.PlanType.Business,
    },
    2226: {
        productFamily: types_1.ProductFamily.Light,
        description: 'premium_plan.product.description.light',
        productCode: types_1.ProductCode.LIGHT,
        type: types_1.PlanType.Business,
    },
    974: {
        productFamily: types_1.ProductFamily.Light,
        description: 'premium_plan.product.description.light',
        productCode: types_1.ProductCode.LIGHT,
        type: types_1.PlanType.Business,
    },
    2001: {
        productFamily: types_1.ProductFamily.Light,
        description: 'premium_plan.product.description.light',
        productCode: types_1.ProductCode.LIGHT,
        type: types_1.PlanType.Business,
    },
    2011: {
        productFamily: types_1.ProductFamily.Light,
        description: 'premium_plan.product.description.light',
        productCode: types_1.ProductCode.LIGHT,
        type: types_1.PlanType.Business,
    },
    2006: {
        productFamily: types_1.ProductFamily.Light,
        description: 'premium_plan.product.description.light',
        productCode: types_1.ProductCode.LIGHT,
        type: types_1.PlanType.Business,
    },
    2016: {
        productFamily: types_1.ProductFamily.Light,
        description: 'premium_plan.product.description.light',
        productCode: types_1.ProductCode.LIGHT,
        type: types_1.PlanType.Business,
    },
    37579: {
        productFamily: types_1.ProductFamily.Light,
        description: 'premium_plan.product.description.light',
        productCode: types_1.ProductCode.LIGHT,
        type: types_1.PlanType.Business,
    },
    2273: {
        productFamily: types_1.ProductFamily.Light,
        description: 'premium_plan.product.description.light',
        productCode: types_1.ProductCode.LIGHT,
        type: types_1.PlanType.Business,
    },
    1212: {
        productFamily: types_1.ProductFamily.Light,
        description: 'premium_plan.product.description.light',
        productCode: types_1.ProductCode.LIGHT,
        type: types_1.PlanType.Business,
    },
    20160: {
        productFamily: types_1.ProductFamily.Light,
        description: 'premium_plan.product.description.light',
        productCode: types_1.ProductCode.LIGHT,
        type: types_1.PlanType.Business,
    },
    2100: {
        productFamily: types_1.ProductFamily.Light,
        description: 'premium_plan.product.description.light',
        productCode: types_1.ProductCode.LIGHT,
        type: types_1.PlanType.Business,
    },
    2113: {
        productFamily: types_1.ProductFamily.Light,
        description: 'premium_plan.product.description.light',
        productCode: types_1.ProductCode.LIGHT,
        type: types_1.PlanType.Business,
    },
    2110: {
        productFamily: types_1.ProductFamily.Light,
        description: 'premium_plan.product.description.light',
        productCode: types_1.ProductCode.LIGHT,
        type: types_1.PlanType.Business,
    },
    2101: {
        productFamily: types_1.ProductFamily.Light,
        description: 'premium_plan.product.description.light',
        productCode: types_1.ProductCode.LIGHT,
        type: types_1.PlanType.Business,
    },
    2121: {
        productFamily: types_1.ProductFamily.Light,
        description: 'premium_plan.product.description.light',
        productCode: types_1.ProductCode.LIGHT,
        type: types_1.PlanType.Business,
    },
    2111: {
        productFamily: types_1.ProductFamily.Light,
        description: 'premium_plan.product.description.light',
        productCode: types_1.ProductCode.LIGHT,
        type: types_1.PlanType.Business,
    },
    2102: {
        productFamily: types_1.ProductFamily.Light,
        description: 'premium_plan.product.description.light',
        productCode: types_1.ProductCode.LIGHT,
        type: types_1.PlanType.Business,
    },
    2122: {
        productFamily: types_1.ProductFamily.Light,
        description: 'premium_plan.product.description.light',
        productCode: types_1.ProductCode.LIGHT,
        type: types_1.PlanType.Business,
    },
    2112: {
        productFamily: types_1.ProductFamily.Light,
        description: 'premium_plan.product.description.light',
        productCode: types_1.ProductCode.LIGHT,
        type: types_1.PlanType.Business,
    },
    2103: {
        productFamily: types_1.ProductFamily.Light,
        description: 'premium_plan.product.description.light',
        productCode: types_1.ProductCode.LIGHT,
        type: types_1.PlanType.Business,
    },
    2123: {
        productFamily: types_1.ProductFamily.Light,
        description: 'premium_plan.product.description.light',
        productCode: types_1.ProductCode.LIGHT,
        type: types_1.PlanType.Business,
    },
    37522: {
        productFamily: types_1.ProductFamily.Light,
        description: 'premium_plan.product.description.light',
        productCode: types_1.ProductCode.LIGHT,
        type: types_1.PlanType.Business,
    },
    37545: {
        productFamily: types_1.ProductFamily.Light,
        description: 'premium_plan.product.description.light',
        productCode: types_1.ProductCode.LIGHT,
        type: types_1.PlanType.Business,
    },
    2104: {
        productFamily: types_1.ProductFamily.Light,
        description: 'premium_plan.product.description.light',
        productCode: types_1.ProductCode.LIGHT,
        type: types_1.PlanType.Business,
    },
    2124: {
        productFamily: types_1.ProductFamily.Light,
        description: 'premium_plan.product.description.light',
        productCode: types_1.ProductCode.LIGHT,
        type: types_1.PlanType.Business,
    },
    37518: {
        productFamily: types_1.ProductFamily.Light,
        description: 'premium_plan.product.description.light',
        productCode: types_1.ProductCode.LIGHT,
        type: types_1.PlanType.Business,
    },
    37535: {
        productFamily: types_1.ProductFamily.Light,
        description: 'premium_plan.product.description.light',
        productCode: types_1.ProductCode.LIGHT,
        type: types_1.PlanType.Business,
    },
    2204: {
        productFamily: types_1.ProductFamily.Light,
        description: 'premium_plan.product.description.light',
        productCode: types_1.ProductCode.LIGHT,
        type: types_1.PlanType.Business,
    },
    2105: {
        productFamily: types_1.ProductFamily.Light,
        description: 'premium_plan.product.description.light',
        productCode: types_1.ProductCode.LIGHT,
        type: types_1.PlanType.Business,
    },
    2115: {
        productFamily: types_1.ProductFamily.Light,
        description: 'premium_plan.product.description.light',
        productCode: types_1.ProductCode.LIGHT,
        type: types_1.PlanType.Business,
    },
    2109: {
        productFamily: types_1.ProductFamily.Light,
        description: 'premium_plan.product.description.light',
        productCode: types_1.ProductCode.LIGHT,
        type: types_1.PlanType.Business,
    },
    2119: {
        productFamily: types_1.ProductFamily.Light,
        description: 'premium_plan.product.description.light',
        productCode: types_1.ProductCode.LIGHT,
        type: types_1.PlanType.Business,
    },
    2106: {
        productFamily: types_1.ProductFamily.Light,
        description: 'premium_plan.product.description.light',
        productCode: types_1.ProductCode.LIGHT,
        type: types_1.PlanType.Business,
    },
    37555: {
        productFamily: types_1.ProductFamily.Light,
        description: 'premium_plan.product.description.light',
        productCode: types_1.ProductCode.LIGHT,
        type: types_1.PlanType.Business,
    },
    2116: {
        productFamily: types_1.ProductFamily.Light,
        description: 'premium_plan.product.description.light',
        productCode: types_1.ProductCode.LIGHT,
        type: types_1.PlanType.Business,
    },
    2107: {
        productFamily: types_1.ProductFamily.Light,
        description: 'premium_plan.product.description.light',
        productCode: types_1.ProductCode.LIGHT,
        type: types_1.PlanType.Business,
    },
    2117: {
        productFamily: types_1.ProductFamily.Light,
        description: 'premium_plan.product.description.light',
        productCode: types_1.ProductCode.LIGHT,
        type: types_1.PlanType.Business,
    },
    37526: {
        productFamily: types_1.ProductFamily.Light,
        description: 'premium_plan.product.description.light',
        productCode: types_1.ProductCode.LIGHT,
        type: types_1.PlanType.Business,
    },
    37540: {
        productFamily: types_1.ProductFamily.Light,
        description: 'premium_plan.product.description.light',
        productCode: types_1.ProductCode.LIGHT,
        type: types_1.PlanType.Business,
    },
    2108: {
        productFamily: types_1.ProductFamily.Light,
        description: 'premium_plan.product.description.light',
        productCode: types_1.ProductCode.LIGHT,
        type: types_1.PlanType.Business,
    },
    2118: {
        productFamily: types_1.ProductFamily.Light,
        description: 'premium_plan.product.description.light',
        productCode: types_1.ProductCode.LIGHT,
        type: types_1.PlanType.Business,
    },
    37550: {
        productFamily: types_1.ProductFamily.Light,
        description: 'premium_plan.product.description.light',
        productCode: types_1.ProductCode.LIGHT,
        type: types_1.PlanType.Business,
    },
    931: {
        productFamily: types_1.ProductFamily.Core,
        description: 'premium_plan.product.description.core',
        productCode: types_1.ProductCode.CORE,
        type: types_1.PlanType.Business,
    },
    2007: {
        productFamily: types_1.ProductFamily.Core,
        description: 'premium_plan.product.description.core',
        productCode: types_1.ProductCode.CORE,
        type: types_1.PlanType.Business,
    },
    37580: {
        productFamily: types_1.ProductFamily.Core,
        description: 'premium_plan.product.description.core',
        productCode: types_1.ProductCode.CORE,
        type: types_1.PlanType.Business,
    },
    2077: {
        productFamily: types_1.ProductFamily.Core,
        description: 'premium_plan.product.description.core',
        productCode: types_1.ProductCode.CORE,
        type: types_1.PlanType.Business,
    },
    2017: {
        productFamily: types_1.ProductFamily.Core,
        description: 'premium_plan.product.description.core',
        productCode: types_1.ProductCode.CORE,
        type: types_1.PlanType.Business,
    },
    9921: {
        productFamily: types_1.ProductFamily.Core,
        description: 'premium_plan.product.description.core',
        productCode: types_1.ProductCode.CORE,
        type: types_1.PlanType.Business,
    },
    9916: {
        productFamily: types_1.ProductFamily.Core,
        description: 'premium_plan.product.description.core',
        productCode: types_1.ProductCode.CORE,
        type: types_1.PlanType.Business,
    },
    9901: {
        productFamily: types_1.ProductFamily.Core,
        description: 'premium_plan.product.description.core',
        productCode: types_1.ProductCode.CORE,
        type: types_1.PlanType.Business,
    },
    9310: {
        productFamily: types_1.ProductFamily.Core,
        description: 'premium_plan.product.description.core',
        productCode: types_1.ProductCode.CORE,
        type: types_1.PlanType.Business,
    },
    2244: {
        productFamily: types_1.ProductFamily.Core,
        description: 'premium_plan.product.description.core',
        productCode: types_1.ProductCode.CORE,
        type: types_1.PlanType.Business,
    },
    2239: {
        productFamily: types_1.ProductFamily.Core,
        description: 'premium_plan.product.description.core',
        productCode: types_1.ProductCode.CORE,
        type: types_1.PlanType.Business,
    },
    2214: {
        productFamily: types_1.ProductFamily.Core,
        description: 'premium_plan.product.description.core',
        productCode: types_1.ProductCode.CORE,
        type: types_1.PlanType.Business,
    },
    9311: {
        productFamily: types_1.ProductFamily.Core,
        description: 'premium_plan.product.description.core',
        productCode: types_1.ProductCode.CORE,
        type: types_1.PlanType.Business,
    },
    2209: {
        productFamily: types_1.ProductFamily.Core,
        description: 'premium_plan.product.description.core',
        productCode: types_1.ProductCode.CORE,
        type: types_1.PlanType.Business,
    },
    9312: {
        productFamily: types_1.ProductFamily.Core,
        description: 'premium_plan.product.description.core',
        productCode: types_1.ProductCode.CORE,
        type: types_1.PlanType.Business,
    },
    2210: {
        productFamily: types_1.ProductFamily.Core,
        description: 'premium_plan.product.description.core',
        productCode: types_1.ProductCode.CORE,
        type: types_1.PlanType.Business,
    },
    9313: {
        productFamily: types_1.ProductFamily.Core,
        description: 'premium_plan.product.description.core',
        productCode: types_1.ProductCode.CORE,
        type: types_1.PlanType.Business,
    },
    2243: {
        productFamily: types_1.ProductFamily.Core,
        description: 'premium_plan.product.description.core',
        productCode: types_1.ProductCode.CORE,
        type: types_1.PlanType.Business,
    },
    2236: {
        productFamily: types_1.ProductFamily.Core,
        description: 'premium_plan.product.description.core',
        productCode: types_1.ProductCode.CORE,
        type: types_1.PlanType.Business,
    },
    2211: {
        productFamily: types_1.ProductFamily.Core,
        description: 'premium_plan.product.description.core',
        productCode: types_1.ProductCode.CORE,
        type: types_1.PlanType.Business,
    },
    9314: {
        productFamily: types_1.ProductFamily.Core,
        description: 'premium_plan.product.description.core',
        productCode: types_1.ProductCode.CORE,
        type: types_1.PlanType.Business,
    },
    2212: {
        productFamily: types_1.ProductFamily.Core,
        description: 'premium_plan.product.description.core',
        productCode: types_1.ProductCode.CORE,
        type: types_1.PlanType.Business,
    },
    9315: {
        productFamily: types_1.ProductFamily.Core,
        description: 'premium_plan.product.description.core',
        productCode: types_1.ProductCode.CORE,
        type: types_1.PlanType.Business,
    },
    2213: {
        productFamily: types_1.ProductFamily.Core,
        description: 'premium_plan.product.description.core',
        productCode: types_1.ProductCode.CORE,
        type: types_1.PlanType.Business,
    },
    9316: {
        productFamily: types_1.ProductFamily.Core,
        description: 'premium_plan.product.description.core',
        productCode: types_1.ProductCode.CORE,
        type: types_1.PlanType.Business,
    },
    2237: {
        productFamily: types_1.ProductFamily.Core,
        description: 'premium_plan.product.description.core',
        productCode: types_1.ProductCode.CORE,
        type: types_1.PlanType.Business,
    },
    9317: {
        productFamily: types_1.ProductFamily.Core,
        description: 'premium_plan.product.description.core',
        productCode: types_1.ProductCode.CORE,
        type: types_1.PlanType.Business,
    },
    2238: {
        productFamily: types_1.ProductFamily.Core,
        description: 'premium_plan.product.description.core',
        productCode: types_1.ProductCode.CORE,
        type: types_1.PlanType.Business,
    },
    941: {
        productFamily: types_1.ProductFamily.Core,
        description: 'premium_plan.product.description.core',
        productCode: types_1.ProductCode.CORE,
        type: types_1.PlanType.Business,
    },
    9410: {
        productFamily: types_1.ProductFamily.Core,
        description: 'premium_plan.product.description.core',
        productCode: types_1.ProductCode.CORE,
        type: types_1.PlanType.Business,
    },
    9800: {
        productFamily: types_1.ProductFamily.Core,
        description: 'premium_plan.product.description.core',
        productCode: types_1.ProductCode.CORE,
        type: types_1.PlanType.Business,
    },
    9411: {
        productFamily: types_1.ProductFamily.Core,
        description: 'premium_plan.product.description.core',
        productCode: types_1.ProductCode.CORE,
        type: types_1.PlanType.Business,
    },
    9807: {
        productFamily: types_1.ProductFamily.Core,
        description: 'premium_plan.product.description.core',
        productCode: types_1.ProductCode.CORE,
        type: types_1.PlanType.Business,
    },
    9412: {
        productFamily: types_1.ProductFamily.Core,
        description: 'premium_plan.product.description.core',
        productCode: types_1.ProductCode.CORE,
        type: types_1.PlanType.Business,
    },
    9808: {
        productFamily: types_1.ProductFamily.Core,
        description: 'premium_plan.product.description.core',
        productCode: types_1.ProductCode.CORE,
        type: types_1.PlanType.Business,
    },
    9413: {
        productFamily: types_1.ProductFamily.Core,
        description: 'premium_plan.product.description.core',
        productCode: types_1.ProductCode.CORE,
        type: types_1.PlanType.Business,
    },
    9920: {
        productFamily: types_1.ProductFamily.Core,
        description: 'premium_plan.product.description.core',
        productCode: types_1.ProductCode.CORE,
        type: types_1.PlanType.Business,
    },
    9915: {
        productFamily: types_1.ProductFamily.Core,
        description: 'premium_plan.product.description.core',
        productCode: types_1.ProductCode.CORE,
        type: types_1.PlanType.Business,
    },
    9904: {
        productFamily: types_1.ProductFamily.Core,
        description: 'premium_plan.product.description.core',
        productCode: types_1.ProductCode.CORE,
        type: types_1.PlanType.Business,
    },
    9900: {
        productFamily: types_1.ProductFamily.Core,
        description: 'premium_plan.product.description.core',
        productCode: types_1.ProductCode.CORE,
        type: types_1.PlanType.Business,
    },
    951: {
        productFamily: types_1.ProductFamily.Core,
        description: 'premium_plan.product.description.core',
        productCode: types_1.ProductCode.CORE,
        type: types_1.PlanType.Business,
    },
    9510: {
        productFamily: types_1.ProductFamily.Core,
        description: 'premium_plan.product.description.core',
        productCode: types_1.ProductCode.CORE,
        type: types_1.PlanType.Business,
    },
    95100: {
        productFamily: types_1.ProductFamily.Core,
        description: 'premium_plan.product.description.core',
        productCode: types_1.ProductCode.CORE,
        type: types_1.PlanType.Business,
    },
    9511: {
        productFamily: types_1.ProductFamily.Core,
        description: 'premium_plan.product.description.core',
        productCode: types_1.ProductCode.CORE,
        type: types_1.PlanType.Business,
    },
    95110: {
        productFamily: types_1.ProductFamily.Core,
        description: 'premium_plan.product.description.core',
        productCode: types_1.ProductCode.CORE,
        type: types_1.PlanType.Business,
    },
    9512: {
        productFamily: types_1.ProductFamily.Core,
        description: 'premium_plan.product.description.core',
        productCode: types_1.ProductCode.CORE,
        type: types_1.PlanType.Business,
    },
    95120: {
        productFamily: types_1.ProductFamily.Core,
        description: 'premium_plan.product.description.core',
        productCode: types_1.ProductCode.CORE,
        type: types_1.PlanType.Business,
    },
    9513: {
        productFamily: types_1.ProductFamily.Core,
        description: 'premium_plan.product.description.core',
        productCode: types_1.ProductCode.CORE,
        type: types_1.PlanType.Business,
    },
    95130: {
        productFamily: types_1.ProductFamily.Core,
        description: 'premium_plan.product.description.core',
        productCode: types_1.ProductCode.CORE,
        type: types_1.PlanType.Business,
    },
    9514: {
        productFamily: types_1.ProductFamily.Core,
        description: 'premium_plan.product.description.core',
        productCode: types_1.ProductCode.CORE,
        type: types_1.PlanType.Business,
    },
    95140: {
        productFamily: types_1.ProductFamily.Core,
        description: 'premium_plan.product.description.core',
        productCode: types_1.ProductCode.CORE,
        type: types_1.PlanType.Business,
    },
    9515: {
        productFamily: types_1.ProductFamily.Core,
        description: 'premium_plan.product.description.core',
        productCode: types_1.ProductCode.CORE,
        type: types_1.PlanType.Business,
    },
    9924: {
        productFamily: types_1.ProductFamily.Core,
        description: 'premium_plan.product.description.core',
        productCode: types_1.ProductCode.CORE,
        type: types_1.PlanType.Business,
    },
    9919: {
        productFamily: types_1.ProductFamily.Core,
        description: 'premium_plan.product.description.core',
        productCode: types_1.ProductCode.CORE,
        type: types_1.PlanType.Business,
    },
    981: {
        productFamily: types_1.ProductFamily.Core,
        description: 'premium_plan.product.description.core',
        productCode: types_1.ProductCode.CORE,
        type: types_1.PlanType.Business,
    },
    2201: {
        productFamily: types_1.ProductFamily.Core,
        description: 'premium_plan.product.description.core',
        productCode: types_1.ProductCode.CORE,
        type: types_1.PlanType.Business,
    },
    22011: {
        productFamily: types_1.ProductFamily.Core,
        description: 'premium_plan.product.description.core',
        productCode: types_1.ProductCode.CORE,
        type: types_1.PlanType.Business,
    },
    37515: {
        productFamily: types_1.ProductFamily.Core,
        description: 'premium_plan.product.description.core',
        productCode: types_1.ProductCode.CORE,
        type: types_1.PlanType.Business,
    },
    37531: {
        productFamily: types_1.ProductFamily.Core,
        description: 'premium_plan.product.description.core',
        productCode: types_1.ProductCode.CORE,
        type: types_1.PlanType.Business,
    },
    37532: {
        productFamily: types_1.ProductFamily.Core,
        description: 'premium_plan.product.description.core',
        productCode: types_1.ProductCode.CORE,
        type: types_1.PlanType.Business,
    },
    22012: {
        productFamily: types_1.ProductFamily.Core,
        description: 'premium_plan.product.description.core',
        productCode: types_1.ProductCode.CORE,
        type: types_1.PlanType.Business,
    },
    936: {
        productFamily: types_1.ProductFamily.Core,
        description: 'premium_plan.product.description.core',
        productCode: types_1.ProductCode.CORE,
        type: types_1.PlanType.Business,
    },
    37523: {
        productFamily: types_1.ProductFamily.Core,
        description: 'premium_plan.product.description.core',
        productCode: types_1.ProductCode.CORE,
        type: types_1.PlanType.Business,
    },
    37546: {
        productFamily: types_1.ProductFamily.Core,
        description: 'premium_plan.product.description.core',
        productCode: types_1.ProductCode.CORE,
        type: types_1.PlanType.Business,
    },
    37547: {
        productFamily: types_1.ProductFamily.Core,
        description: 'premium_plan.product.description.core',
        productCode: types_1.ProductCode.CORE,
        type: types_1.PlanType.Business,
    },
    946: {
        productFamily: types_1.ProductFamily.Core,
        description: 'premium_plan.product.description.core',
        productCode: types_1.ProductCode.CORE,
        type: types_1.PlanType.Business,
    },
    2206: {
        productFamily: types_1.ProductFamily.Core,
        description: 'premium_plan.product.description.core',
        productCode: types_1.ProductCode.CORE,
        type: types_1.PlanType.Business,
    },
    37519: {
        productFamily: types_1.ProductFamily.Core,
        description: 'premium_plan.product.description.core',
        productCode: types_1.ProductCode.CORE,
        type: types_1.PlanType.Business,
    },
    37536: {
        productFamily: types_1.ProductFamily.Core,
        description: 'premium_plan.product.description.core',
        productCode: types_1.ProductCode.CORE,
        type: types_1.PlanType.Business,
    },
    37537: {
        productFamily: types_1.ProductFamily.Core,
        description: 'premium_plan.product.description.core',
        productCode: types_1.ProductCode.CORE,
        type: types_1.PlanType.Business,
    },
    956: {
        productFamily: types_1.ProductFamily.Core,
        description: 'premium_plan.product.description.core',
        productCode: types_1.ProductCode.CORE,
        type: types_1.PlanType.Business,
    },
    37527: {
        productFamily: types_1.ProductFamily.Core,
        description: 'premium_plan.product.description.core',
        productCode: types_1.ProductCode.CORE,
        type: types_1.PlanType.Business,
    },
    37541: {
        productFamily: types_1.ProductFamily.Core,
        description: 'premium_plan.product.description.core',
        productCode: types_1.ProductCode.CORE,
        type: types_1.PlanType.Business,
    },
    37542: {
        productFamily: types_1.ProductFamily.Core,
        description: 'premium_plan.product.description.core',
        productCode: types_1.ProductCode.CORE,
        type: types_1.PlanType.Business,
    },
    961: {
        productFamily: types_1.ProductFamily.Core,
        description: 'premium_plan.product.description.core',
        productCode: types_1.ProductCode.CORE,
        type: types_1.PlanType.Business,
    },
    9615: {
        productFamily: types_1.ProductFamily.Core,
        description: 'premium_plan.product.description.core',
        productCode: types_1.ProductCode.CORE,
        type: types_1.PlanType.Business,
    },
    9923: {
        productFamily: types_1.ProductFamily.Core,
        description: 'premium_plan.product.description.core',
        productCode: types_1.ProductCode.CORE,
        type: types_1.PlanType.Business,
    },
    9918: {
        productFamily: types_1.ProductFamily.Core,
        description: 'premium_plan.product.description.core',
        productCode: types_1.ProductCode.CORE,
        type: types_1.PlanType.Business,
    },
    9903: {
        productFamily: types_1.ProductFamily.Core,
        description: 'premium_plan.product.description.core',
        productCode: types_1.ProductCode.CORE,
        type: types_1.PlanType.Business,
    },
    9610: {
        productFamily: types_1.ProductFamily.Core,
        description: 'premium_plan.product.description.core',
        productCode: types_1.ProductCode.CORE,
        type: types_1.PlanType.Business,
    },
    96100: {
        productFamily: types_1.ProductFamily.Core,
        description: 'premium_plan.product.description.core',
        productCode: types_1.ProductCode.CORE,
        type: types_1.PlanType.Business,
    },
    9611: {
        productFamily: types_1.ProductFamily.Core,
        description: 'premium_plan.product.description.core',
        productCode: types_1.ProductCode.CORE,
        type: types_1.PlanType.Business,
    },
    96110: {
        productFamily: types_1.ProductFamily.Core,
        description: 'premium_plan.product.description.core',
        productCode: types_1.ProductCode.CORE,
        type: types_1.PlanType.Business,
    },
    9612: {
        productFamily: types_1.ProductFamily.Core,
        description: 'premium_plan.product.description.core',
        productCode: types_1.ProductCode.CORE,
        type: types_1.PlanType.Business,
    },
    96120: {
        productFamily: types_1.ProductFamily.Core,
        description: 'premium_plan.product.description.core',
        productCode: types_1.ProductCode.CORE,
        type: types_1.PlanType.Business,
    },
    9613: {
        productFamily: types_1.ProductFamily.Core,
        description: 'premium_plan.product.description.core',
        productCode: types_1.ProductCode.CORE,
        type: types_1.PlanType.Business,
    },
    96130: {
        productFamily: types_1.ProductFamily.Core,
        description: 'premium_plan.product.description.core',
        productCode: types_1.ProductCode.CORE,
        type: types_1.PlanType.Business,
    },
    9614: {
        productFamily: types_1.ProductFamily.Core,
        description: 'premium_plan.product.description.core',
        productCode: types_1.ProductCode.CORE,
        type: types_1.PlanType.Business,
    },
    96140: {
        productFamily: types_1.ProductFamily.Core,
        description: 'premium_plan.product.description.core',
        productCode: types_1.ProductCode.CORE,
        type: types_1.PlanType.Business,
    },
    971: {
        productFamily: types_1.ProductFamily.Core,
        description: 'premium_plan.product.description.core',
        productCode: types_1.ProductCode.CORE,
        type: types_1.PlanType.Business,
    },
    37556: {
        productFamily: types_1.ProductFamily.Core,
        description: 'premium_plan.product.description.core',
        productCode: types_1.ProductCode.CORE,
        type: types_1.PlanType.Business,
    },
    37557: {
        productFamily: types_1.ProductFamily.Core,
        description: 'premium_plan.product.description.core',
        productCode: types_1.ProductCode.CORE,
        type: types_1.PlanType.Business,
    },
    9710: {
        productFamily: types_1.ProductFamily.Core,
        description: 'premium_plan.product.description.core',
        productCode: types_1.ProductCode.CORE,
        type: types_1.PlanType.Business,
    },
    2245: {
        productFamily: types_1.ProductFamily.Core,
        description: 'premium_plan.product.description.core',
        productCode: types_1.ProductCode.CORE,
        type: types_1.PlanType.Business,
    },
    2242: {
        productFamily: types_1.ProductFamily.Core,
        description: 'premium_plan.product.description.core',
        productCode: types_1.ProductCode.CORE,
        type: types_1.PlanType.Business,
    },
    2217: {
        productFamily: types_1.ProductFamily.Core,
        description: 'premium_plan.product.description.core',
        productCode: types_1.ProductCode.CORE,
        type: types_1.PlanType.Business,
    },
    9711: {
        productFamily: types_1.ProductFamily.Core,
        description: 'premium_plan.product.description.core',
        productCode: types_1.ProductCode.CORE,
        type: types_1.PlanType.Business,
    },
    2215: {
        productFamily: types_1.ProductFamily.Core,
        description: 'premium_plan.product.description.core',
        productCode: types_1.ProductCode.CORE,
        type: types_1.PlanType.Business,
    },
    9712: {
        productFamily: types_1.ProductFamily.Core,
        description: 'premium_plan.product.description.core',
        productCode: types_1.ProductCode.CORE,
        type: types_1.PlanType.Business,
    },
    2216: {
        productFamily: types_1.ProductFamily.Core,
        description: 'premium_plan.product.description.core',
        productCode: types_1.ProductCode.CORE,
        type: types_1.PlanType.Business,
    },
    9713: {
        productFamily: types_1.ProductFamily.Core,
        description: 'premium_plan.product.description.core',
        productCode: types_1.ProductCode.CORE,
        type: types_1.PlanType.Business,
    },
    37551: {
        productFamily: types_1.ProductFamily.Core,
        description: 'premium_plan.product.description.core',
        productCode: types_1.ProductCode.CORE,
        type: types_1.PlanType.Business,
    },
    37552: {
        productFamily: types_1.ProductFamily.Core,
        description: 'premium_plan.product.description.core',
        productCode: types_1.ProductCode.CORE,
        type: types_1.PlanType.Business,
    },
    9922: {
        productFamily: types_1.ProductFamily.Core,
        description: 'premium_plan.product.description.core',
        productCode: types_1.ProductCode.CORE,
        type: types_1.PlanType.Business,
    },
    9917: {
        productFamily: types_1.ProductFamily.Core,
        description: 'premium_plan.product.description.core',
        productCode: types_1.ProductCode.CORE,
        type: types_1.PlanType.Business,
    },
    9902: {
        productFamily: types_1.ProductFamily.Core,
        description: 'premium_plan.product.description.core',
        productCode: types_1.ProductCode.CORE,
        type: types_1.PlanType.Business,
    },
    9714: {
        productFamily: types_1.ProductFamily.Core,
        description: 'premium_plan.product.description.core',
        productCode: types_1.ProductCode.CORE,
        type: types_1.PlanType.Business,
    },
    2240: {
        productFamily: types_1.ProductFamily.Core,
        description: 'premium_plan.product.description.core',
        productCode: types_1.ProductCode.CORE,
        type: types_1.PlanType.Business,
    },
    9715: {
        productFamily: types_1.ProductFamily.Core,
        description: 'premium_plan.product.description.core',
        productCode: types_1.ProductCode.CORE,
        type: types_1.PlanType.Business,
    },
    2241: {
        productFamily: types_1.ProductFamily.Core,
        description: 'premium_plan.product.description.core',
        productCode: types_1.ProductCode.CORE,
        type: types_1.PlanType.Business,
    },
    975: {
        productFamily: types_1.ProductFamily.Core,
        description: 'premium_plan.product.description.core',
        productCode: types_1.ProductCode.CORE,
        type: types_1.PlanType.Business,
    },
    9750: {
        productFamily: types_1.ProductFamily.Core,
        description: 'premium_plan.product.description.core',
        productCode: types_1.ProductCode.CORE,
        type: types_1.PlanType.Business,
    },
    2002: {
        productFamily: types_1.ProductFamily.Core,
        description: 'premium_plan.product.description.core',
        productCode: types_1.ProductCode.CORE,
        type: types_1.PlanType.Business,
    },
    932: {
        productFamily: types_1.ProductFamily.Business,
        description: 'premium_plan.product.description.business',
        productCode: types_1.ProductCode.BUSINESS,
        hatKey: 'premium-purchase-plan.main_table.hat.recommended',
        type: types_1.PlanType.Business,
        popular: true,
    },
    9320: {
        productFamily: types_1.ProductFamily.Business,
        description: 'premium_plan.product.description.business',
        productCode: types_1.ProductCode.BUSINESS,
        hatKey: 'premium-purchase-plan.main_table.hat.recommended',
        type: types_1.PlanType.Business,
        popular: true,
    },
    2232: {
        productFamily: types_1.ProductFamily.Business,
        description: 'premium_plan.product.description.business',
        productCode: types_1.ProductCode.BUSINESS,
        hatKey: 'premium-purchase-plan.main_table.hat.recommended',
        type: types_1.PlanType.Business,
        popular: true,
    },
    9321: {
        productFamily: types_1.ProductFamily.Business,
        description: 'premium_plan.product.description.business',
        productCode: types_1.ProductCode.BUSINESS,
        hatKey: 'premium-purchase-plan.main_table.hat.recommended',
        type: types_1.PlanType.Business,
        popular: true,
    },
    2227: {
        productFamily: types_1.ProductFamily.Business,
        description: 'premium_plan.product.description.business',
        productCode: types_1.ProductCode.BUSINESS,
        hatKey: 'premium-purchase-plan.main_table.hat.recommended',
        type: types_1.PlanType.Business,
        popular: true,
    },
    9322: {
        productFamily: types_1.ProductFamily.Business,
        description: 'premium_plan.product.description.business',
        productCode: types_1.ProductCode.BUSINESS,
        hatKey: 'premium-purchase-plan.main_table.hat.recommended',
        type: types_1.PlanType.Business,
        popular: true,
    },
    2228: {
        productFamily: types_1.ProductFamily.Business,
        description: 'premium_plan.product.description.business',
        productCode: types_1.ProductCode.BUSINESS,
        hatKey: 'premium-purchase-plan.main_table.hat.recommended',
        type: types_1.PlanType.Business,
        popular: true,
    },
    9323: {
        productFamily: types_1.ProductFamily.Business,
        description: 'premium_plan.product.description.business',
        productCode: types_1.ProductCode.BUSINESS,
        hatKey: 'premium-purchase-plan.main_table.hat.recommended',
        type: types_1.PlanType.Business,
        popular: true,
    },
    2229: {
        productFamily: types_1.ProductFamily.Business,
        description: 'premium_plan.product.description.business',
        productCode: types_1.ProductCode.BUSINESS,
        hatKey: 'premium-purchase-plan.main_table.hat.recommended',
        type: types_1.PlanType.Business,
        popular: true,
    },
    9324: {
        productFamily: types_1.ProductFamily.Business,
        description: 'premium_plan.product.description.business',
        productCode: types_1.ProductCode.BUSINESS,
        hatKey: 'premium-purchase-plan.main_table.hat.recommended',
        type: types_1.PlanType.Business,
        popular: true,
    },
    2230: {
        productFamily: types_1.ProductFamily.Business,
        description: 'premium_plan.product.description.business',
        productCode: types_1.ProductCode.BUSINESS,
        hatKey: 'premium-purchase-plan.main_table.hat.recommended',
        type: types_1.PlanType.Business,
        popular: true,
    },
    9325: {
        productFamily: types_1.ProductFamily.Business,
        description: 'premium_plan.product.description.business',
        productCode: types_1.ProductCode.BUSINESS,
        hatKey: 'premium-purchase-plan.main_table.hat.recommended',
        type: types_1.PlanType.Business,
        popular: true,
    },
    2231: {
        productFamily: types_1.ProductFamily.Business,
        description: 'premium_plan.product.description.business',
        productCode: types_1.ProductCode.BUSINESS,
        hatKey: 'premium-purchase-plan.main_table.hat.recommended',
        type: types_1.PlanType.Business,
        popular: true,
    },
    9326: {
        productFamily: types_1.ProductFamily.Business,
        description: 'premium_plan.product.description.business',
        productCode: types_1.ProductCode.BUSINESS,
        hatKey: 'premium-purchase-plan.main_table.hat.recommended',
        type: types_1.PlanType.Business,
        popular: true,
    },
    2247: {
        productFamily: types_1.ProductFamily.Business,
        description: 'premium_plan.product.description.business',
        productCode: types_1.ProductCode.BUSINESS,
        hatKey: 'premium-purchase-plan.main_table.hat.recommended',
        type: types_1.PlanType.Business,
        popular: true,
    },
    9327: {
        productFamily: types_1.ProductFamily.Business,
        description: 'premium_plan.product.description.business',
        productCode: types_1.ProductCode.BUSINESS,
        hatKey: 'premium-purchase-plan.main_table.hat.recommended',
        type: types_1.PlanType.Business,
        popular: true,
    },
    2248: {
        productFamily: types_1.ProductFamily.Business,
        description: 'premium_plan.product.description.business',
        productCode: types_1.ProductCode.BUSINESS,
        hatKey: 'premium-purchase-plan.main_table.hat.recommended',
        type: types_1.PlanType.Business,
        popular: true,
    },
    9328: {
        productFamily: types_1.ProductFamily.Business,
        description: 'premium_plan.product.description.business',
        productCode: types_1.ProductCode.BUSINESS,
        hatKey: 'premium-purchase-plan.main_table.hat.recommended',
        type: types_1.PlanType.Business,
        popular: true,
    },
    2246: {
        productFamily: types_1.ProductFamily.Business,
        description: 'premium_plan.product.description.business',
        productCode: types_1.ProductCode.BUSINESS,
        hatKey: 'premium-purchase-plan.main_table.hat.recommended',
        type: types_1.PlanType.Business,
        popular: true,
    },
    2008: {
        productFamily: types_1.ProductFamily.Business,
        description: 'premium_plan.product.description.business',
        productCode: types_1.ProductCode.BUSINESS,
        hatKey: 'premium-purchase-plan.main_table.hat.recommended',
        type: types_1.PlanType.Business,
        popular: true,
    },
    2009: {
        productFamily: types_1.ProductFamily.Business,
        description: 'premium_plan.product.description.business',
        productCode: types_1.ProductCode.BUSINESS,
        hatKey: 'premium-purchase-plan.main_table.hat.recommended',
        type: types_1.PlanType.Business,
        popular: true,
    },
    2010: {
        productFamily: types_1.ProductFamily.Business,
        description: 'premium_plan.product.description.business',
        productCode: types_1.ProductCode.BUSINESS,
        hatKey: 'premium-purchase-plan.main_table.hat.recommended',
        type: types_1.PlanType.Business,
        popular: true,
    },
    2099: {
        productFamily: types_1.ProductFamily.Business,
        description: 'premium_plan.product.description.business',
        productCode: types_1.ProductCode.BUSINESS,
        hatKey: 'premium-purchase-plan.main_table.hat.recommended',
        type: types_1.PlanType.Business,
        popular: true,
    },
    2019: {
        productFamily: types_1.ProductFamily.Business,
        description: 'premium_plan.product.description.business',
        productCode: types_1.ProductCode.BUSINESS,
        hatKey: 'premium-purchase-plan.main_table.hat.recommended',
        type: types_1.PlanType.Business,
        popular: true,
    },
    9926: {
        productFamily: types_1.ProductFamily.Business,
        description: 'premium_plan.product.description.business',
        productCode: types_1.ProductCode.BUSINESS,
        hatKey: 'premium-purchase-plan.main_table.hat.recommended',
        type: types_1.PlanType.Business,
        popular: true,
    },
    9911: {
        productFamily: types_1.ProductFamily.Business,
        description: 'premium_plan.product.description.business',
        productCode: types_1.ProductCode.BUSINESS,
        hatKey: 'premium-purchase-plan.main_table.hat.recommended',
        type: types_1.PlanType.Business,
        popular: true,
    },
    9906: {
        productFamily: types_1.ProductFamily.Business,
        description: 'premium_plan.product.description.business',
        productCode: types_1.ProductCode.BUSINESS,
        hatKey: 'premium-purchase-plan.main_table.hat.recommended',
        type: types_1.PlanType.Business,
        popular: true,
    },
    942: {
        productFamily: types_1.ProductFamily.Business,
        description: 'premium_plan.product.description.business',
        productCode: types_1.ProductCode.BUSINESS,
        hatKey: 'premium-purchase-plan.main_table.hat.recommended',
        type: types_1.PlanType.Business,
        popular: true,
    },
    9420: {
        productFamily: types_1.ProductFamily.Business,
        description: 'premium_plan.product.description.business',
        productCode: types_1.ProductCode.BUSINESS,
        hatKey: 'premium-purchase-plan.main_table.hat.recommended',
        type: types_1.PlanType.Business,
        popular: true,
    },
    9806: {
        productFamily: types_1.ProductFamily.Business,
        description: 'premium_plan.product.description.business',
        productCode: types_1.ProductCode.BUSINESS,
        hatKey: 'premium-purchase-plan.main_table.hat.recommended',
        type: types_1.PlanType.Business,
        popular: true,
    },
    9421: {
        productFamily: types_1.ProductFamily.Business,
        description: 'premium_plan.product.description.business',
        productCode: types_1.ProductCode.BUSINESS,
        hatKey: 'premium-purchase-plan.main_table.hat.recommended',
        type: types_1.PlanType.Business,
        popular: true,
    },
    9805: {
        productFamily: types_1.ProductFamily.Business,
        description: 'premium_plan.product.description.business',
        productCode: types_1.ProductCode.BUSINESS,
        hatKey: 'premium-purchase-plan.main_table.hat.recommended',
        type: types_1.PlanType.Business,
        popular: true,
    },
    9422: {
        productFamily: types_1.ProductFamily.Business,
        description: 'premium_plan.product.description.business',
        productCode: types_1.ProductCode.BUSINESS,
        hatKey: 'premium-purchase-plan.main_table.hat.recommended',
        type: types_1.PlanType.Business,
        popular: true,
    },
    9810: {
        productFamily: types_1.ProductFamily.Business,
        description: 'premium_plan.product.description.business',
        productCode: types_1.ProductCode.BUSINESS,
        hatKey: 'premium-purchase-plan.main_table.hat.recommended',
        type: types_1.PlanType.Business,
        popular: true,
    },
    9423: {
        productFamily: types_1.ProductFamily.Business,
        description: 'premium_plan.product.description.business',
        productCode: types_1.ProductCode.BUSINESS,
        hatKey: 'premium-purchase-plan.main_table.hat.recommended',
        type: types_1.PlanType.Business,
        popular: true,
    },
    9809: {
        productFamily: types_1.ProductFamily.Business,
        description: 'premium_plan.product.description.business',
        productCode: types_1.ProductCode.BUSINESS,
        hatKey: 'premium-purchase-plan.main_table.hat.recommended',
        type: types_1.PlanType.Business,
        popular: true,
    },
    9424: {
        productFamily: types_1.ProductFamily.Business,
        description: 'premium_plan.product.description.business',
        productCode: types_1.ProductCode.BUSINESS,
        hatKey: 'premium-purchase-plan.main_table.hat.recommended',
        type: types_1.PlanType.Business,
        popular: true,
    },
    9925: {
        productFamily: types_1.ProductFamily.Business,
        description: 'premium_plan.product.description.business',
        productCode: types_1.ProductCode.BUSINESS,
        hatKey: 'premium-purchase-plan.main_table.hat.recommended',
        type: types_1.PlanType.Business,
        popular: true,
    },
    9910: {
        productFamily: types_1.ProductFamily.Business,
        description: 'premium_plan.product.description.business',
        productCode: types_1.ProductCode.BUSINESS,
        hatKey: 'premium-purchase-plan.main_table.hat.recommended',
        type: types_1.PlanType.Business,
        popular: true,
    },
    9905: {
        productFamily: types_1.ProductFamily.Business,
        description: 'premium_plan.product.description.business',
        productCode: types_1.ProductCode.BUSINESS,
        hatKey: 'premium-purchase-plan.main_table.hat.recommended',
        type: types_1.PlanType.Business,
        popular: true,
    },
    952: {
        productFamily: types_1.ProductFamily.Business,
        description: 'premium_plan.product.description.business',
        productCode: types_1.ProductCode.BUSINESS,
        hatKey: 'premium-purchase-plan.main_table.hat.recommended',
        type: types_1.PlanType.Business,
        popular: true,
    },
    9520: {
        productFamily: types_1.ProductFamily.Business,
        description: 'premium_plan.product.description.business',
        productCode: types_1.ProductCode.BUSINESS,
        hatKey: 'premium-purchase-plan.main_table.hat.recommended',
        type: types_1.PlanType.Business,
        popular: true,
    },
    95200: {
        productFamily: types_1.ProductFamily.Business,
        description: 'premium_plan.product.description.business',
        productCode: types_1.ProductCode.BUSINESS,
        hatKey: 'premium-purchase-plan.main_table.hat.recommended',
        type: types_1.PlanType.Business,
        popular: true,
    },
    9521: {
        productFamily: types_1.ProductFamily.Business,
        description: 'premium_plan.product.description.business',
        productCode: types_1.ProductCode.BUSINESS,
        hatKey: 'premium-purchase-plan.main_table.hat.recommended',
        type: types_1.PlanType.Business,
        popular: true,
    },
    95210: {
        productFamily: types_1.ProductFamily.Business,
        description: 'premium_plan.product.description.business',
        productCode: types_1.ProductCode.BUSINESS,
        hatKey: 'premium-purchase-plan.main_table.hat.recommended',
        type: types_1.PlanType.Business,
        popular: true,
    },
    9522: {
        productFamily: types_1.ProductFamily.Business,
        description: 'premium_plan.product.description.business',
        productCode: types_1.ProductCode.BUSINESS,
        hatKey: 'premium-purchase-plan.main_table.hat.recommended',
        type: types_1.PlanType.Business,
        popular: true,
    },
    95220: {
        productFamily: types_1.ProductFamily.Business,
        description: 'premium_plan.product.description.business',
        productCode: types_1.ProductCode.BUSINESS,
        hatKey: 'premium-purchase-plan.main_table.hat.recommended',
        type: types_1.PlanType.Business,
        popular: true,
    },
    9523: {
        productFamily: types_1.ProductFamily.Business,
        description: 'premium_plan.product.description.business',
        productCode: types_1.ProductCode.BUSINESS,
        hatKey: 'premium-purchase-plan.main_table.hat.recommended',
        type: types_1.PlanType.Business,
        popular: true,
    },
    95230: {
        productFamily: types_1.ProductFamily.Business,
        description: 'premium_plan.product.description.business',
        productCode: types_1.ProductCode.BUSINESS,
        hatKey: 'premium-purchase-plan.main_table.hat.recommended',
        type: types_1.PlanType.Business,
        popular: true,
    },
    9524: {
        productFamily: types_1.ProductFamily.Business,
        description: 'premium_plan.product.description.business',
        productCode: types_1.ProductCode.BUSINESS,
        hatKey: 'premium-purchase-plan.main_table.hat.recommended',
        type: types_1.PlanType.Business,
        popular: true,
    },
    9929: {
        productFamily: types_1.ProductFamily.Business,
        description: 'premium_plan.product.description.business',
        productCode: types_1.ProductCode.BUSINESS,
        hatKey: 'premium-purchase-plan.main_table.hat.recommended',
        type: types_1.PlanType.Business,
        popular: true,
    },
    9914: {
        productFamily: types_1.ProductFamily.Business,
        description: 'premium_plan.product.description.business',
        productCode: types_1.ProductCode.BUSINESS,
        hatKey: 'premium-purchase-plan.main_table.hat.recommended',
        type: types_1.PlanType.Business,
        popular: true,
    },
    9909: {
        productFamily: types_1.ProductFamily.Business,
        description: 'premium_plan.product.description.business',
        productCode: types_1.ProductCode.BUSINESS,
        hatKey: 'premium-purchase-plan.main_table.hat.recommended',
        type: types_1.PlanType.Business,
        popular: true,
    },
    982: {
        productFamily: types_1.ProductFamily.Business,
        description: 'premium_plan.product.description.business',
        productCode: types_1.ProductCode.BUSINESS,
        hatKey: 'premium-purchase-plan.main_table.hat.recommended',
        type: types_1.PlanType.Business,
        popular: true,
    },
    37516: {
        productFamily: types_1.ProductFamily.Business,
        description: 'premium_plan.product.description.business',
        productCode: types_1.ProductCode.BUSINESS,
        hatKey: 'premium-purchase-plan.main_table.hat.recommended',
        type: types_1.PlanType.Business,
        popular: true,
    },
    37533: {
        productFamily: types_1.ProductFamily.Business,
        description: 'premium_plan.product.description.business',
        productCode: types_1.ProductCode.BUSINESS,
        hatKey: 'premium-purchase-plan.main_table.hat.recommended',
        type: types_1.PlanType.Business,
        popular: true,
    },
    37534: {
        productFamily: types_1.ProductFamily.Business,
        description: 'premium_plan.product.description.business',
        productCode: types_1.ProductCode.BUSINESS,
        hatKey: 'premium-purchase-plan.main_table.hat.recommended',
        type: types_1.PlanType.Business,
        popular: true,
    },
    2202: {
        productFamily: types_1.ProductFamily.Business,
        description: 'premium_plan.product.description.business',
        productCode: types_1.ProductCode.BUSINESS,
        hatKey: 'premium-purchase-plan.main_table.hat.recommended',
        type: types_1.PlanType.Business,
        popular: true,
    },
    937: {
        productFamily: types_1.ProductFamily.Business,
        description: 'premium_plan.product.description.business',
        productCode: types_1.ProductCode.BUSINESS,
        hatKey: 'premium-purchase-plan.main_table.hat.recommended',
        type: types_1.PlanType.Business,
        popular: true,
    },
    37524: {
        productFamily: types_1.ProductFamily.Business,
        description: 'premium_plan.product.description.business',
        productCode: types_1.ProductCode.BUSINESS,
        hatKey: 'premium-purchase-plan.main_table.hat.recommended',
        type: types_1.PlanType.Business,
        popular: true,
    },
    37548: {
        productFamily: types_1.ProductFamily.Business,
        description: 'premium_plan.product.description.business',
        productCode: types_1.ProductCode.BUSINESS,
        hatKey: 'premium-purchase-plan.main_table.hat.recommended',
        type: types_1.PlanType.Business,
        popular: true,
    },
    37549: {
        productFamily: types_1.ProductFamily.Business,
        description: 'premium_plan.product.description.business',
        productCode: types_1.ProductCode.BUSINESS,
        hatKey: 'premium-purchase-plan.main_table.hat.recommended',
        type: types_1.PlanType.Business,
        popular: true,
    },
    947: {
        productFamily: types_1.ProductFamily.Business,
        description: 'premium_plan.product.description.business',
        productCode: types_1.ProductCode.BUSINESS,
        hatKey: 'premium-purchase-plan.main_table.hat.recommended',
        type: types_1.PlanType.Business,
        popular: true,
    },
    2207: {
        productFamily: types_1.ProductFamily.Business,
        description: 'premium_plan.product.description.business',
        productCode: types_1.ProductCode.BUSINESS,
        hatKey: 'premium-purchase-plan.main_table.hat.recommended',
        type: types_1.PlanType.Business,
        popular: true,
    },
    37520: {
        productFamily: types_1.ProductFamily.Business,
        description: 'premium_plan.product.description.business',
        productCode: types_1.ProductCode.BUSINESS,
        hatKey: 'premium-purchase-plan.main_table.hat.recommended',
        type: types_1.PlanType.Business,
        popular: true,
    },
    37538: {
        productFamily: types_1.ProductFamily.Business,
        description: 'premium_plan.product.description.business',
        productCode: types_1.ProductCode.BUSINESS,
        hatKey: 'premium-purchase-plan.main_table.hat.recommended',
        type: types_1.PlanType.Business,
        popular: true,
    },
    37539: {
        productFamily: types_1.ProductFamily.Business,
        description: 'premium_plan.product.description.business',
        productCode: types_1.ProductCode.BUSINESS,
        hatKey: 'premium-purchase-plan.main_table.hat.recommended',
        type: types_1.PlanType.Business,
        popular: true,
    },
    957: {
        productFamily: types_1.ProductFamily.Business,
        description: 'premium_plan.product.description.business',
        productCode: types_1.ProductCode.BUSINESS,
        hatKey: 'premium-purchase-plan.main_table.hat.recommended',
        type: types_1.PlanType.Business,
        popular: true,
    },
    959: {
        productFamily: types_1.ProductFamily.Business,
        description: 'premium_plan.product.description.business',
        productCode: types_1.ProductCode.BUSINESS,
        hatKey: 'premium-purchase-plan.main_table.hat.recommended',
        type: types_1.PlanType.Business,
        popular: true,
    },
    37528: {
        productFamily: types_1.ProductFamily.Business,
        description: 'premium_plan.product.description.business',
        productCode: types_1.ProductCode.BUSINESS,
        hatKey: 'premium-purchase-plan.main_table.hat.recommended',
        type: types_1.PlanType.Business,
        popular: true,
    },
    37543: {
        productFamily: types_1.ProductFamily.Business,
        description: 'premium_plan.product.description.business',
        productCode: types_1.ProductCode.BUSINESS,
        hatKey: 'premium-purchase-plan.main_table.hat.recommended',
        type: types_1.PlanType.Business,
        popular: true,
    },
    37544: {
        productFamily: types_1.ProductFamily.Business,
        description: 'premium_plan.product.description.business',
        productCode: types_1.ProductCode.BUSINESS,
        hatKey: 'premium-purchase-plan.main_table.hat.recommended',
        type: types_1.PlanType.Business,
        popular: true,
    },
    962: {
        productFamily: types_1.ProductFamily.Business,
        description: 'premium_plan.product.description.business',
        productCode: types_1.ProductCode.BUSINESS,
        hatKey: 'premium-purchase-plan.main_table.hat.recommended',
        type: types_1.PlanType.Business,
        popular: true,
    },
    9624: {
        productFamily: types_1.ProductFamily.Business,
        description: 'premium_plan.product.description.business',
        productCode: types_1.ProductCode.BUSINESS,
        hatKey: 'premium-purchase-plan.main_table.hat.recommended',
        type: types_1.PlanType.Business,
        popular: true,
    },
    9928: {
        productFamily: types_1.ProductFamily.Business,
        description: 'premium_plan.product.description.business',
        productCode: types_1.ProductCode.BUSINESS,
        hatKey: 'premium-purchase-plan.main_table.hat.recommended',
        type: types_1.PlanType.Business,
        popular: true,
    },
    9913: {
        productFamily: types_1.ProductFamily.Business,
        description: 'premium_plan.product.description.business',
        productCode: types_1.ProductCode.BUSINESS,
        hatKey: 'premium-purchase-plan.main_table.hat.recommended',
        type: types_1.PlanType.Business,
        popular: true,
    },
    9908: {
        productFamily: types_1.ProductFamily.Business,
        description: 'premium_plan.product.description.business',
        productCode: types_1.ProductCode.BUSINESS,
        hatKey: 'premium-purchase-plan.main_table.hat.recommended',
        type: types_1.PlanType.Business,
        popular: true,
    },
    9620: {
        productFamily: types_1.ProductFamily.Business,
        description: 'premium_plan.product.description.business',
        productCode: types_1.ProductCode.BUSINESS,
        hatKey: 'premium-purchase-plan.main_table.hat.recommended',
        type: types_1.PlanType.Business,
        popular: true,
    },
    96200: {
        productFamily: types_1.ProductFamily.Business,
        description: 'premium_plan.product.description.business',
        productCode: types_1.ProductCode.BUSINESS,
        hatKey: 'premium-purchase-plan.main_table.hat.recommended',
        type: types_1.PlanType.Business,
        popular: true,
    },
    9621: {
        productFamily: types_1.ProductFamily.Business,
        description: 'premium_plan.product.description.business',
        productCode: types_1.ProductCode.BUSINESS,
        hatKey: 'premium-purchase-plan.main_table.hat.recommended',
        type: types_1.PlanType.Business,
        popular: true,
    },
    96210: {
        productFamily: types_1.ProductFamily.Business,
        description: 'premium_plan.product.description.business',
        productCode: types_1.ProductCode.BUSINESS,
        hatKey: 'premium-purchase-plan.main_table.hat.recommended',
        type: types_1.PlanType.Business,
        popular: true,
    },
    9622: {
        productFamily: types_1.ProductFamily.Business,
        description: 'premium_plan.product.description.business',
        productCode: types_1.ProductCode.BUSINESS,
        hatKey: 'premium-purchase-plan.main_table.hat.recommended',
        type: types_1.PlanType.Business,
        popular: true,
    },
    96220: {
        productFamily: types_1.ProductFamily.Business,
        description: 'premium_plan.product.description.business',
        productCode: types_1.ProductCode.BUSINESS,
        hatKey: 'premium-purchase-plan.main_table.hat.recommended',
        type: types_1.PlanType.Business,
        popular: true,
    },
    9623: {
        productFamily: types_1.ProductFamily.Business,
        description: 'premium_plan.product.description.business',
        productCode: types_1.ProductCode.BUSINESS,
        hatKey: 'premium-purchase-plan.main_table.hat.recommended',
        type: types_1.PlanType.Business,
        popular: true,
    },
    96230: {
        productFamily: types_1.ProductFamily.Business,
        description: 'premium_plan.product.description.business',
        productCode: types_1.ProductCode.BUSINESS,
        hatKey: 'premium-purchase-plan.main_table.hat.recommended',
        type: types_1.PlanType.Business,
        popular: true,
    },
    972: {
        productFamily: types_1.ProductFamily.Business,
        description: 'premium_plan.product.description.business',
        productCode: types_1.ProductCode.BUSINESS,
        hatKey: 'premium-purchase-plan.main_table.hat.recommended',
        type: types_1.PlanType.Business,
        popular: true,
    },
    37558: {
        productFamily: types_1.ProductFamily.Business,
        description: 'premium_plan.product.description.business',
        productCode: types_1.ProductCode.BUSINESS,
        hatKey: 'premium-purchase-plan.main_table.hat.recommended',
        type: types_1.PlanType.Business,
        popular: true,
    },
    37559: {
        productFamily: types_1.ProductFamily.Business,
        description: 'premium_plan.product.description.business',
        productCode: types_1.ProductCode.BUSINESS,
        hatKey: 'premium-purchase-plan.main_table.hat.recommended',
        type: types_1.PlanType.Business,
        popular: true,
    },
    9720: {
        productFamily: types_1.ProductFamily.Business,
        description: 'premium_plan.product.description.business',
        productCode: types_1.ProductCode.BUSINESS,
        hatKey: 'premium-purchase-plan.main_table.hat.recommended',
        type: types_1.PlanType.Business,
        popular: true,
    },
    9721: {
        productFamily: types_1.ProductFamily.Business,
        description: 'premium_plan.product.description.business',
        productCode: types_1.ProductCode.BUSINESS,
        hatKey: 'premium-purchase-plan.main_table.hat.recommended',
        type: types_1.PlanType.Business,
        popular: true,
    },
    37553: {
        productFamily: types_1.ProductFamily.Business,
        description: 'premium_plan.product.description.business',
        productCode: types_1.ProductCode.BUSINESS,
        hatKey: 'premium-purchase-plan.main_table.hat.recommended',
        type: types_1.PlanType.Business,
        popular: true,
    },
    37554: {
        productFamily: types_1.ProductFamily.Business,
        description: 'premium_plan.product.description.business',
        productCode: types_1.ProductCode.BUSINESS,
        hatKey: 'premium-purchase-plan.main_table.hat.recommended',
        type: types_1.PlanType.Business,
        popular: true,
    },
    9927: {
        productFamily: types_1.ProductFamily.Business,
        description: 'premium_plan.product.description.business',
        productCode: types_1.ProductCode.BUSINESS,
        hatKey: 'premium-purchase-plan.main_table.hat.recommended',
        type: types_1.PlanType.Business,
        popular: true,
    },
    9912: {
        productFamily: types_1.ProductFamily.Business,
        description: 'premium_plan.product.description.business',
        productCode: types_1.ProductCode.BUSINESS,
        hatKey: 'premium-purchase-plan.main_table.hat.recommended',
        type: types_1.PlanType.Business,
        popular: true,
    },
    9907: {
        productFamily: types_1.ProductFamily.Business,
        description: 'premium_plan.product.description.business',
        productCode: types_1.ProductCode.BUSINESS,
        hatKey: 'premium-purchase-plan.main_table.hat.recommended',
        type: types_1.PlanType.Business,
        popular: true,
    },
    9722: {
        productFamily: types_1.ProductFamily.Business,
        description: 'premium_plan.product.description.business',
        productCode: types_1.ProductCode.BUSINESS,
        hatKey: 'premium-purchase-plan.main_table.hat.recommended',
        type: types_1.PlanType.Business,
        popular: true,
    },
    2235: {
        productFamily: types_1.ProductFamily.Business,
        description: 'premium_plan.product.description.business',
        productCode: types_1.ProductCode.BUSINESS,
        hatKey: 'premium-purchase-plan.main_table.hat.recommended',
        type: types_1.PlanType.Business,
        popular: true,
    },
    9723: {
        productFamily: types_1.ProductFamily.Business,
        description: 'premium_plan.product.description.business',
        productCode: types_1.ProductCode.BUSINESS,
        hatKey: 'premium-purchase-plan.main_table.hat.recommended',
        type: types_1.PlanType.Business,
        popular: true,
    },
    2233: {
        productFamily: types_1.ProductFamily.Business,
        description: 'premium_plan.product.description.business',
        productCode: types_1.ProductCode.BUSINESS,
        hatKey: 'premium-purchase-plan.main_table.hat.recommended',
        type: types_1.PlanType.Business,
        popular: true,
    },
    9724: {
        productFamily: types_1.ProductFamily.Business,
        description: 'premium_plan.product.description.business',
        productCode: types_1.ProductCode.BUSINESS,
        hatKey: 'premium-purchase-plan.main_table.hat.recommended',
        type: types_1.PlanType.Business,
        popular: true,
    },
    2234: {
        productFamily: types_1.ProductFamily.Business,
        description: 'premium_plan.product.description.business',
        productCode: types_1.ProductCode.BUSINESS,
        hatKey: 'premium-purchase-plan.main_table.hat.recommended',
        type: types_1.PlanType.Business,
        popular: true,
    },
    9725: {
        productFamily: types_1.ProductFamily.Business,
        description: 'premium_plan.product.description.business',
        productCode: types_1.ProductCode.BUSINESS,
        hatKey: 'premium-purchase-plan.main_table.hat.recommended',
        type: types_1.PlanType.Business,
        popular: true,
    },
    9726: {
        productFamily: types_1.ProductFamily.Business,
        description: 'premium_plan.product.description.business',
        productCode: types_1.ProductCode.BUSINESS,
        hatKey: 'premium-purchase-plan.main_table.hat.recommended',
        type: types_1.PlanType.Business,
        popular: true,
    },
    2249: {
        productFamily: types_1.ProductFamily.Business,
        description: 'premium_plan.product.description.business',
        productCode: types_1.ProductCode.BUSINESS,
        hatKey: 'premium-purchase-plan.main_table.hat.recommended',
        type: types_1.PlanType.Business,
        popular: true,
    },
    976: {
        productFamily: types_1.ProductFamily.Business,
        description: 'premium_plan.product.description.business',
        productCode: types_1.ProductCode.BUSINESS,
        hatKey: 'premium-purchase-plan.main_table.hat.recommended',
        type: types_1.PlanType.Business,
        popular: true,
    },
    9760: {
        productFamily: types_1.ProductFamily.Business,
        description: 'premium_plan.product.description.business',
        productCode: types_1.ProductCode.BUSINESS,
        hatKey: 'premium-purchase-plan.main_table.hat.recommended',
        type: types_1.PlanType.Business,
        popular: true,
    },
    9761: {
        productFamily: types_1.ProductFamily.Business,
        description: 'premium_plan.product.description.business',
        productCode: types_1.ProductCode.BUSINESS,
        hatKey: 'premium-purchase-plan.main_table.hat.recommended',
        type: types_1.PlanType.Business,
        popular: true,
    },
    2003: {
        productFamily: types_1.ProductFamily.Business,
        description: 'premium_plan.product.description.business',
        productCode: types_1.ProductCode.BUSINESS,
        hatKey: 'premium-purchase-plan.main_table.hat.recommended',
        type: types_1.PlanType.Business,
        popular: true,
    },
    933: {
        productFamily: types_1.ProductFamily.Elite,
        description: 'premium_plan.product.description.business_elite',
        productCode: types_1.ProductCode.BUSINESS_ELITE,
        type: types_1.PlanType.Business,
    },
    37581: {
        productFamily: types_1.ProductFamily.Elite,
        description: 'premium_plan.product.description.business_elite',
        productCode: types_1.ProductCode.BUSINESS_ELITE,
        type: types_1.PlanType.Business,
    },
    943: {
        productFamily: types_1.ProductFamily.Elite,
        description: 'premium_plan.product.description.business_elite',
        productCode: types_1.ProductCode.BUSINESS_ELITE,
        type: types_1.PlanType.Business,
    },
    953: {
        productFamily: types_1.ProductFamily.Elite,
        description: 'premium_plan.product.description.business_elite',
        productCode: types_1.ProductCode.BUSINESS_ELITE,
        type: types_1.PlanType.Business,
    },
    983: {
        productFamily: types_1.ProductFamily.Elite,
        description: 'premium_plan.product.description.business_elite',
        productCode: types_1.ProductCode.BUSINESS_ELITE,
        type: types_1.PlanType.Business,
    },
    37517: {
        productFamily: types_1.ProductFamily.Elite,
        description: 'premium_plan.product.description.business_elite',
        productCode: types_1.ProductCode.BUSINESS_ELITE,
        type: types_1.PlanType.Business,
    },
    2203: {
        productFamily: types_1.ProductFamily.Elite,
        description: 'premium_plan.product.description.business_elite',
        productCode: types_1.ProductCode.BUSINESS_ELITE,
        type: types_1.PlanType.Business,
    },
    938: {
        productFamily: types_1.ProductFamily.Elite,
        description: 'premium_plan.product.description.business_elite',
        productCode: types_1.ProductCode.BUSINESS_ELITE,
        type: types_1.PlanType.Business,
    },
    37525: {
        productFamily: types_1.ProductFamily.Elite,
        description: 'premium_plan.product.description.business_elite',
        productCode: types_1.ProductCode.BUSINESS_ELITE,
        type: types_1.PlanType.Business,
    },
    939: {
        productFamily: types_1.ProductFamily.Elite,
        description: 'premium_plan.product.description.business_elite',
        productCode: types_1.ProductCode.BUSINESS_ELITE,
        type: types_1.PlanType.Business,
    },
    948: {
        productFamily: types_1.ProductFamily.Elite,
        description: 'premium_plan.product.description.business_elite',
        productCode: types_1.ProductCode.BUSINESS_ELITE,
        type: types_1.PlanType.Business,
    },
    2208: {
        productFamily: types_1.ProductFamily.Elite,
        description: 'premium_plan.product.description.business_elite',
        productCode: types_1.ProductCode.BUSINESS_ELITE,
        type: types_1.PlanType.Business,
    },
    37521: {
        productFamily: types_1.ProductFamily.Elite,
        description: 'premium_plan.product.description.business_elite',
        productCode: types_1.ProductCode.BUSINESS_ELITE,
        type: types_1.PlanType.Business,
    },
    958: {
        productFamily: types_1.ProductFamily.Elite,
        description: 'premium_plan.product.description.business_elite',
        productCode: types_1.ProductCode.BUSINESS_ELITE,
        type: types_1.PlanType.Business,
    },
    37529: {
        productFamily: types_1.ProductFamily.Elite,
        description: 'premium_plan.product.description.business_elite',
        productCode: types_1.ProductCode.BUSINESS_ELITE,
        type: types_1.PlanType.Business,
    },
    963: {
        productFamily: types_1.ProductFamily.Elite,
        description: 'premium_plan.product.description.business_elite',
        productCode: types_1.ProductCode.BUSINESS_ELITE,
        type: types_1.PlanType.Business,
    },
    973: {
        productFamily: types_1.ProductFamily.Elite,
        description: 'premium_plan.product.description.business_elite',
        productCode: types_1.ProductCode.BUSINESS_ELITE,
        type: types_1.PlanType.Business,
    },
    977: {
        productFamily: types_1.ProductFamily.Elite,
        description: 'premium_plan.product.description.business_elite',
        productCode: types_1.ProductCode.BUSINESS_ELITE,
        type: types_1.PlanType.Business,
    },
    2004: {
        productFamily: types_1.ProductFamily.Elite,
        description: 'premium_plan.product.description.business_elite',
        productCode: types_1.ProductCode.BUSINESS_ELITE,
        type: types_1.PlanType.Business,
    },
    934: {
        productFamily: types_1.ProductFamily.Enterprise,
        description: 'premium_plan.product.description.enterprise',
        productCode: types_1.ProductCode.ENTERPRISE,
        type: types_1.PlanType.Business,
    },
    2005: {
        productFamily: types_1.ProductFamily.Enterprise,
        description: 'premium_plan.product.description.enterprise',
        productCode: types_1.ProductCode.ENTERPRISE,
        type: types_1.PlanType.Business,
    },
    822: {
        productFamily: types_1.ProductFamily.ConnectDomain,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_CONNECT_DOMAIN, ".description"),
        productCode: types_1.ProductCode.WEBSITE_CONNECT_DOMAIN,
        shouldShowAdsNote: true,
    },
    823: {
        productFamily: types_1.ProductFamily.Combo,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_COMBO, ".description"),
        productCode: types_1.ProductCode.WEBSITE_COMBO,
    },
    824: {
        productFamily: types_1.ProductFamily.Unlimited,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_UNLIMITED, ".description"),
        productCode: types_1.ProductCode.WEBSITE_UNLIMITED,
    },
    832: {
        productFamily: types_1.ProductFamily.VIP,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_VIP, ".description"),
        productCode: types_1.ProductCode.WEBSITE_VIP,
    },
    833: {
        productFamily: types_1.ProductFamily.Default,
        type: types_1.PlanType.Business,
        description: "premium_plan.".concat(types_1.ProductCode.BUSINESS_BASIC, ".description"),
        productCode: types_1.ProductCode.BUSINESS_BASIC,
    },
    834: {
        productFamily: types_1.ProductFamily.Unlimited,
        type: types_1.PlanType.Business,
        description: "premium_plan.".concat(types_1.ProductCode.BUSINESS_UNLIMITED, ".description"),
        productCode: types_1.ProductCode.BUSINESS_UNLIMITED,
    },
    835: {
        productFamily: types_1.ProductFamily.VIP,
        type: types_1.PlanType.Business,
        description: "premium_plan.".concat(types_1.ProductCode.BUSINESS_VIP, ".description"),
        productCode: types_1.ProductCode.BUSINESS_VIP,
    },
    825: {
        productFamily: types_1.ProductFamily.ConnectDomain,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_CONNECT_DOMAIN, ".description"),
        productCode: types_1.ProductCode.WEBSITE_CONNECT_DOMAIN,
        shouldShowAdsNote: true,
    },
    826: {
        productFamily: types_1.ProductFamily.Combo,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_COMBO, ".description"),
        productCode: types_1.ProductCode.WEBSITE_COMBO,
    },
    827: {
        productFamily: types_1.ProductFamily.Unlimited,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_UNLIMITED, ".description"),
        productCode: types_1.ProductCode.WEBSITE_UNLIMITED,
    },
    828: {
        productFamily: types_1.ProductFamily.VIP,
        type: types_1.PlanType.Website,
        description: "premium_plan.".concat(types_1.ProductCode.WEBSITE_VIP, ".description"),
        productCode: types_1.ProductCode.WEBSITE_VIP,
    },
    829: {
        productFamily: types_1.ProductFamily.Default,
        type: types_1.PlanType.Business,
        description: "premium_plan.".concat(types_1.ProductCode.BUSINESS_BASIC, ".description"),
        productCode: types_1.ProductCode.BUSINESS_BASIC,
    },
    830: {
        productFamily: types_1.ProductFamily.Unlimited,
        type: types_1.PlanType.Business,
        description: "premium_plan.".concat(types_1.ProductCode.BUSINESS_UNLIMITED, ".description"),
        productCode: types_1.ProductCode.BUSINESS_UNLIMITED,
    },
    831: {
        productFamily: types_1.ProductFamily.VIP,
        type: types_1.PlanType.Business,
        description: "premium_plan.".concat(types_1.ProductCode.BUSINESS_VIP, ".description"),
        productCode: types_1.ProductCode.BUSINESS_VIP,
    },
    840: {
        productFamily: types_1.ProductFamily.Basic,
        type: types_1.PlanType.Business,
        description: "studio_package_picker.product.description.basic",
        productCode: types_1.ProductCode.STUDIO_BASIC,
    },
    8400: {
        productFamily: types_1.ProductFamily.Basic,
        type: types_1.PlanType.Business,
        description: "studio_package_picker.product.description.basic",
        productCode: types_1.ProductCode.STUDIO_BASIC,
    },
    8401: {
        productFamily: types_1.ProductFamily.Basic,
        type: types_1.PlanType.Business,
        description: "studio_package_picker.product.description.basic",
        productCode: types_1.ProductCode.STUDIO_BASIC,
    },
    841: {
        productFamily: types_1.ProductFamily.Standard,
        type: types_1.PlanType.Business,
        description: "studio_package_picker.product.description.standard",
        productCode: types_1.ProductCode.STUDIO_STANDARD,
    },
    8410: {
        productFamily: types_1.ProductFamily.Standard,
        type: types_1.PlanType.Business,
        description: "studio_package_picker.product.description.standard",
        productCode: types_1.ProductCode.STUDIO_STANDARD,
    },
    842: {
        productFamily: types_1.ProductFamily.Plus,
        type: types_1.PlanType.Business,
        description: "studio_package_picker.product.description.plus",
        productCode: types_1.ProductCode.STUDIO_PLUS,
        popular: true,
        hatKey: 'studio_package_picker.cards.hat.recommended',
    },
    8420: {
        productFamily: types_1.ProductFamily.Plus,
        type: types_1.PlanType.Business,
        description: "studio_package_picker.product.description.plus",
        productCode: types_1.ProductCode.STUDIO_PLUS,
        popular: true,
        hatKey: 'studio_package_picker.cards.hat.recommended',
    },
    843: {
        productFamily: types_1.ProductFamily.Elite,
        type: types_1.PlanType.Business,
        description: "studio_package_picker.product.description.advanced",
        productCode: types_1.ProductCode.STUDIO_ELITE,
    },
    8430: {
        productFamily: types_1.ProductFamily.Elite,
        type: types_1.PlanType.Business,
        description: "studio_package_picker.product.description.advanced",
        productCode: types_1.ProductCode.STUDIO_ELITE,
    },
    844: {
        productFamily: types_1.ProductFamily.Enterprise,
        description: 'studio_package_picker.product.description.enterprise',
        productCode: types_1.ProductCode.ENTERPRISE,
        type: types_1.PlanType.Business,
    },
    850: {
        productFamily: types_1.ProductFamily.Basic,
        type: types_1.PlanType.Business,
        description: "studio_package_picker.product.description.basic",
        productCode: types_1.ProductCode.STUDIO_BASIC,
    },
    8500: {
        productFamily: types_1.ProductFamily.Basic,
        type: types_1.PlanType.Business,
        description: "studio_package_picker.product.description.basic",
        productCode: types_1.ProductCode.STUDIO_BASIC,
    },
    8501: {
        productFamily: types_1.ProductFamily.Basic,
        type: types_1.PlanType.Business,
        description: "studio_package_picker.product.description.basic",
        productCode: types_1.ProductCode.STUDIO_BASIC,
    },
    851: {
        productFamily: types_1.ProductFamily.Standard,
        type: types_1.PlanType.Business,
        description: "studio_package_picker.product.description.standard",
        productCode: types_1.ProductCode.STUDIO_STANDARD,
    },
    8510: {
        productFamily: types_1.ProductFamily.Standard,
        type: types_1.PlanType.Business,
        description: "studio_package_picker.product.description.standard",
        productCode: types_1.ProductCode.STUDIO_STANDARD,
    },
    852: {
        productFamily: types_1.ProductFamily.Plus,
        type: types_1.PlanType.Business,
        description: "studio_package_picker.product.description.plus",
        productCode: types_1.ProductCode.STUDIO_PLUS,
        popular: true,
        hatKey: 'studio_package_picker.cards.hat.recommended',
    },
    8520: {
        productFamily: types_1.ProductFamily.Plus,
        type: types_1.PlanType.Business,
        description: "studio_package_picker.product.description.plus",
        productCode: types_1.ProductCode.STUDIO_PLUS,
        popular: true,
        hatKey: 'studio_package_picker.cards.hat.recommended',
    },
    853: {
        productFamily: types_1.ProductFamily.Elite,
        type: types_1.PlanType.Business,
        description: "studio_package_picker.product.description.advanced",
        productCode: types_1.ProductCode.STUDIO_ELITE,
    },
    8530: {
        productFamily: types_1.ProductFamily.Elite,
        type: types_1.PlanType.Business,
        description: "studio_package_picker.product.description.advanced",
        productCode: types_1.ProductCode.STUDIO_ELITE,
    },
    855: {
        productFamily: types_1.ProductFamily.Basic,
        type: types_1.PlanType.Business,
        description: "studio_package_picker.product.description.basic",
        productCode: types_1.ProductCode.STUDIO_BASIC,
    },
    8550: {
        productFamily: types_1.ProductFamily.Basic,
        type: types_1.PlanType.Business,
        description: "studio_package_picker.product.description.basic",
        productCode: types_1.ProductCode.STUDIO_BASIC,
    },
    8551: {
        productFamily: types_1.ProductFamily.Basic,
        type: types_1.PlanType.Business,
        description: "studio_package_picker.product.description.basic",
        productCode: types_1.ProductCode.STUDIO_BASIC,
    },
    856: {
        productFamily: types_1.ProductFamily.Standard,
        type: types_1.PlanType.Business,
        description: "studio_package_picker.product.description.standard",
        productCode: types_1.ProductCode.STUDIO_STANDARD,
    },
    8560: {
        productFamily: types_1.ProductFamily.Standard,
        type: types_1.PlanType.Business,
        description: "studio_package_picker.product.description.standard",
        productCode: types_1.ProductCode.STUDIO_STANDARD,
    },
    857: {
        productFamily: types_1.ProductFamily.Plus,
        type: types_1.PlanType.Business,
        description: "studio_package_picker.product.description.plus",
        productCode: types_1.ProductCode.STUDIO_PLUS,
        popular: true,
        hatKey: 'studio_package_picker.cards.hat.recommended',
    },
    8570: {
        productFamily: types_1.ProductFamily.Plus,
        type: types_1.PlanType.Business,
        description: "studio_package_picker.product.description.plus",
        productCode: types_1.ProductCode.STUDIO_PLUS,
        popular: true,
        hatKey: 'studio_package_picker.cards.hat.recommended',
    },
    858: {
        productFamily: types_1.ProductFamily.Elite,
        type: types_1.PlanType.Business,
        description: "studio_package_picker.product.description.advanced",
        productCode: types_1.ProductCode.STUDIO_ELITE,
    },
    859: {
        productFamily: types_1.ProductFamily.Elite,
        type: types_1.PlanType.Business,
        description: "studio_package_picker.product.description.advanced",
        productCode: types_1.ProductCode.STUDIO_ELITE,
    },
    860: {
        productFamily: types_1.ProductFamily.Basic,
        type: types_1.PlanType.Business,
        description: "studio_package_picker.product.description.basic",
        productCode: types_1.ProductCode.STUDIO_BASIC,
    },
    8600: {
        productFamily: types_1.ProductFamily.Basic,
        type: types_1.PlanType.Business,
        description: "studio_package_picker.product.description.basic",
        productCode: types_1.ProductCode.STUDIO_BASIC,
    },
    8601: {
        productFamily: types_1.ProductFamily.Basic,
        type: types_1.PlanType.Business,
        description: "studio_package_picker.product.description.basic",
        productCode: types_1.ProductCode.STUDIO_BASIC,
    },
    861: {
        productFamily: types_1.ProductFamily.Standard,
        type: types_1.PlanType.Business,
        description: "studio_package_picker.product.description.standard",
        productCode: types_1.ProductCode.STUDIO_STANDARD,
    },
    8610: {
        productFamily: types_1.ProductFamily.Standard,
        type: types_1.PlanType.Business,
        description: "studio_package_picker.product.description.standard",
        productCode: types_1.ProductCode.STUDIO_STANDARD,
    },
    862: {
        productFamily: types_1.ProductFamily.Plus,
        type: types_1.PlanType.Business,
        description: "studio_package_picker.product.description.plus",
        productCode: types_1.ProductCode.STUDIO_PLUS,
        popular: true,
        hatKey: 'studio_package_picker.cards.hat.recommended',
    },
    8620: {
        productFamily: types_1.ProductFamily.Plus,
        type: types_1.PlanType.Business,
        description: "studio_package_picker.product.description.plus",
        productCode: types_1.ProductCode.STUDIO_PLUS,
        popular: true,
        hatKey: 'studio_package_picker.cards.hat.recommended',
    },
    863: {
        productFamily: types_1.ProductFamily.Elite,
        type: types_1.PlanType.Business,
        description: "studio_package_picker.product.description.advanced",
        productCode: types_1.ProductCode.STUDIO_ELITE,
    },
    864: {
        productFamily: types_1.ProductFamily.Elite,
        type: types_1.PlanType.Business,
        description: "studio_package_picker.product.description.advanced",
        productCode: types_1.ProductCode.STUDIO_ELITE,
    },
    865: {
        productFamily: types_1.ProductFamily.Basic,
        type: types_1.PlanType.Business,
        description: "studio_package_picker.product.description.basic",
        productCode: types_1.ProductCode.STUDIO_BASIC,
    },
    866: {
        productFamily: types_1.ProductFamily.Standard,
        type: types_1.PlanType.Business,
        description: "studio_package_picker.product.description.standard",
        productCode: types_1.ProductCode.STUDIO_STANDARD,
    },
    867: {
        productFamily: types_1.ProductFamily.Plus,
        type: types_1.PlanType.Business,
        description: "studio_package_picker.product.description.plus",
        productCode: types_1.ProductCode.STUDIO_PLUS,
        popular: true,
        hatKey: 'studio_package_picker.cards.hat.recommended',
    },
    868: {
        productFamily: types_1.ProductFamily.Elite,
        type: types_1.PlanType.Business,
        description: "studio_package_picker.product.description.advanced",
        productCode: types_1.ProductCode.STUDIO_ELITE,
    },
    870: {
        productFamily: types_1.ProductFamily.Basic,
        type: types_1.PlanType.Business,
        description: "studio_package_picker.product.description.basic",
        productCode: types_1.ProductCode.STUDIO_BASIC,
    },
    8700: {
        productFamily: types_1.ProductFamily.Basic,
        type: types_1.PlanType.Business,
        description: "studio_package_picker.product.description.basic",
        productCode: types_1.ProductCode.STUDIO_BASIC,
    },
    8701: {
        productFamily: types_1.ProductFamily.Basic,
        type: types_1.PlanType.Business,
        description: "studio_package_picker.product.description.basic",
        productCode: types_1.ProductCode.STUDIO_BASIC,
    },
    871: {
        productFamily: types_1.ProductFamily.Standard,
        type: types_1.PlanType.Business,
        description: "studio_package_picker.product.description.standard",
        productCode: types_1.ProductCode.STUDIO_STANDARD,
    },
    8710: {
        productFamily: types_1.ProductFamily.Standard,
        type: types_1.PlanType.Business,
        description: "studio_package_picker.product.description.standard",
        productCode: types_1.ProductCode.STUDIO_STANDARD,
    },
    872: {
        productFamily: types_1.ProductFamily.Plus,
        type: types_1.PlanType.Business,
        description: "studio_package_picker.product.description.plus",
        productCode: types_1.ProductCode.STUDIO_PLUS,
        popular: true,
        hatKey: 'studio_package_picker.cards.hat.recommended',
    },
    8720: {
        productFamily: types_1.ProductFamily.Plus,
        type: types_1.PlanType.Business,
        description: "studio_package_picker.product.description.plus",
        productCode: types_1.ProductCode.STUDIO_PLUS,
        popular: true,
        hatKey: 'studio_package_picker.cards.hat.recommended',
    },
    873: {
        productFamily: types_1.ProductFamily.Elite,
        type: types_1.PlanType.Business,
        description: "studio_package_picker.product.description.advanced",
        productCode: types_1.ProductCode.STUDIO_ELITE,
    },
    8730: {
        productFamily: types_1.ProductFamily.Elite,
        type: types_1.PlanType.Business,
        description: "studio_package_picker.product.description.advanced",
        productCode: types_1.ProductCode.STUDIO_ELITE,
    },
    875: {
        productFamily: types_1.ProductFamily.Basic,
        type: types_1.PlanType.Business,
        description: "studio_package_picker.product.description.basic",
        productCode: types_1.ProductCode.STUDIO_BASIC,
    },
    8750: {
        productFamily: types_1.ProductFamily.Basic,
        type: types_1.PlanType.Business,
        description: "studio_package_picker.product.description.basic",
        productCode: types_1.ProductCode.STUDIO_BASIC,
    },
    8752: {
        productFamily: types_1.ProductFamily.Basic,
        type: types_1.PlanType.Business,
        description: "studio_package_picker.product.description.basic",
        productCode: types_1.ProductCode.STUDIO_BASIC,
    },
    8751: {
        productFamily: types_1.ProductFamily.Basic,
        type: types_1.PlanType.Business,
        description: "studio_package_picker.product.description.basic",
        productCode: types_1.ProductCode.STUDIO_BASIC,
    },
    876: {
        productFamily: types_1.ProductFamily.Standard,
        type: types_1.PlanType.Business,
        description: "studio_package_picker.product.description.standard",
        productCode: types_1.ProductCode.STUDIO_STANDARD,
    },
    8761: {
        productFamily: types_1.ProductFamily.Standard,
        type: types_1.PlanType.Business,
        description: "studio_package_picker.product.description.standard",
        productCode: types_1.ProductCode.STUDIO_STANDARD,
    },
    8760: {
        productFamily: types_1.ProductFamily.Standard,
        type: types_1.PlanType.Business,
        description: "studio_package_picker.product.description.standard",
        productCode: types_1.ProductCode.STUDIO_STANDARD,
    },
    877: {
        productFamily: types_1.ProductFamily.Plus,
        type: types_1.PlanType.Business,
        description: "studio_package_picker.product.description.plus",
        productCode: types_1.ProductCode.STUDIO_PLUS,
        popular: true,
        hatKey: 'studio_package_picker.cards.hat.recommended',
    },
    8771: {
        productFamily: types_1.ProductFamily.Plus,
        type: types_1.PlanType.Business,
        description: "studio_package_picker.product.description.plus",
        productCode: types_1.ProductCode.STUDIO_PLUS,
        popular: true,
        hatKey: 'studio_package_picker.cards.hat.recommended',
    },
    8770: {
        productFamily: types_1.ProductFamily.Plus,
        type: types_1.PlanType.Business,
        description: "studio_package_picker.product.description.plus",
        productCode: types_1.ProductCode.STUDIO_PLUS,
        popular: true,
        hatKey: 'studio_package_picker.cards.hat.recommended',
    },
    878: {
        productFamily: types_1.ProductFamily.Elite,
        type: types_1.PlanType.Business,
        description: "studio_package_picker.product.description.advanced",
        productCode: types_1.ProductCode.STUDIO_ELITE,
    },
    8780: {
        productFamily: types_1.ProductFamily.Elite,
        type: types_1.PlanType.Business,
        description: "studio_package_picker.product.description.advanced",
        productCode: types_1.ProductCode.STUDIO_ELITE,
    },
    879: {
        productFamily: types_1.ProductFamily.Elite,
        type: types_1.PlanType.Business,
        description: "studio_package_picker.product.description.advanced",
        productCode: types_1.ProductCode.STUDIO_ELITE,
    },
    880: {
        productFamily: types_1.ProductFamily.Basic,
        type: types_1.PlanType.Business,
        description: "studio_package_picker.product.description.basic",
        productCode: types_1.ProductCode.STUDIO_BASIC,
    },
    8801: {
        productFamily: types_1.ProductFamily.Basic,
        type: types_1.PlanType.Business,
        description: "studio_package_picker.product.description.basic",
        productCode: types_1.ProductCode.STUDIO_BASIC,
    },
    8800: {
        productFamily: types_1.ProductFamily.Basic,
        type: types_1.PlanType.Business,
        description: "studio_package_picker.product.description.basic",
        productCode: types_1.ProductCode.STUDIO_BASIC,
    },
    8802: {
        productFamily: types_1.ProductFamily.Basic,
        type: types_1.PlanType.Business,
        description: "studio_package_picker.product.description.basic",
        productCode: types_1.ProductCode.STUDIO_BASIC,
    },
    881: {
        productFamily: types_1.ProductFamily.Standard,
        type: types_1.PlanType.Business,
        description: "studio_package_picker.product.description.standard",
        productCode: types_1.ProductCode.STUDIO_STANDARD,
    },
    8811: {
        productFamily: types_1.ProductFamily.Standard,
        type: types_1.PlanType.Business,
        description: "studio_package_picker.product.description.standard",
        productCode: types_1.ProductCode.STUDIO_STANDARD,
    },
    8810: {
        productFamily: types_1.ProductFamily.Standard,
        type: types_1.PlanType.Business,
        description: "studio_package_picker.product.description.standard",
        productCode: types_1.ProductCode.STUDIO_STANDARD,
    },
    882: {
        productFamily: types_1.ProductFamily.Plus,
        type: types_1.PlanType.Business,
        description: "studio_package_picker.product.description.plus",
        productCode: types_1.ProductCode.STUDIO_PLUS,
        popular: true,
        hatKey: 'studio_package_picker.cards.hat.recommended',
    },
    8821: {
        productFamily: types_1.ProductFamily.Plus,
        type: types_1.PlanType.Business,
        description: "studio_package_picker.product.description.plus",
        productCode: types_1.ProductCode.STUDIO_PLUS,
        popular: true,
        hatKey: 'studio_package_picker.cards.hat.recommended',
    },
    8820: {
        productFamily: types_1.ProductFamily.Plus,
        type: types_1.PlanType.Business,
        description: "studio_package_picker.product.description.plus",
        productCode: types_1.ProductCode.STUDIO_PLUS,
        popular: true,
        hatKey: 'studio_package_picker.cards.hat.recommended',
    },
    883: {
        productFamily: types_1.ProductFamily.Elite,
        type: types_1.PlanType.Business,
        description: "studio_package_picker.product.description.advanced",
        productCode: types_1.ProductCode.STUDIO_ELITE,
    },
    8830: {
        productFamily: types_1.ProductFamily.Elite,
        type: types_1.PlanType.Business,
        description: "studio_package_picker.product.description.advanced",
        productCode: types_1.ProductCode.STUDIO_ELITE,
    },
    884: {
        productFamily: types_1.ProductFamily.Elite,
        type: types_1.PlanType.Business,
        description: "studio_package_picker.product.description.advanced",
        productCode: types_1.ProductCode.STUDIO_ELITE,
    },
    885: {
        productFamily: types_1.ProductFamily.Basic,
        type: types_1.PlanType.Business,
        description: "studio_package_picker.product.description.basic",
        productCode: types_1.ProductCode.STUDIO_BASIC,
    },
    8850: {
        productFamily: types_1.ProductFamily.Basic,
        type: types_1.PlanType.Business,
        description: "studio_package_picker.product.description.basic",
        productCode: types_1.ProductCode.STUDIO_BASIC,
    },
    8851: {
        productFamily: types_1.ProductFamily.Basic,
        type: types_1.PlanType.Business,
        description: "studio_package_picker.product.description.basic",
        productCode: types_1.ProductCode.STUDIO_BASIC,
    },
    886: {
        productFamily: types_1.ProductFamily.Standard,
        type: types_1.PlanType.Business,
        description: "studio_package_picker.product.description.standard",
        productCode: types_1.ProductCode.STUDIO_STANDARD,
    },
    8860: {
        productFamily: types_1.ProductFamily.Standard,
        type: types_1.PlanType.Business,
        description: "studio_package_picker.product.description.standard",
        productCode: types_1.ProductCode.STUDIO_STANDARD,
    },
    887: {
        productFamily: types_1.ProductFamily.Plus,
        type: types_1.PlanType.Business,
        description: "studio_package_picker.product.description.plus",
        productCode: types_1.ProductCode.STUDIO_PLUS,
        popular: true,
        hatKey: 'studio_package_picker.cards.hat.recommended',
    },
    8870: {
        productFamily: types_1.ProductFamily.Plus,
        type: types_1.PlanType.Business,
        description: "studio_package_picker.product.description.plus",
        productCode: types_1.ProductCode.STUDIO_PLUS,
        popular: true,
        hatKey: 'studio_package_picker.cards.hat.recommended',
    },
    888: {
        productFamily: types_1.ProductFamily.Elite,
        type: types_1.PlanType.Business,
        description: "studio_package_picker.product.description.advanced",
        productCode: types_1.ProductCode.STUDIO_ELITE,
    },
    890: {
        productFamily: types_1.ProductFamily.Elite,
        type: types_1.PlanType.Business,
        description: "studio_package_picker.product.description.advanced",
        productCode: types_1.ProductCode.STUDIO_ELITE,
    },
};
exports.STUDIO_BASIC_PLANS = [
    '840',
    '8400',
    '8401',
    '850',
    '8500',
    '8501',
    '855',
    '8550',
    '8551',
    '860',
    '8600',
    '8601',
    '865',
    '870',
    '8700',
    '8701',
    '875',
    '8750',
    '8752',
    '8751',
    '880',
    '8801',
    '8800',
    '8802',
    '885',
    '8850',
    '8851',
];
exports.STUDIO_STANDARD_PLANS = [
    '841',
    '8410',
    '851',
    '8510',
    '856',
    '8560',
    '861',
    '8610',
    '866',
    '871',
    '8710',
    '876',
    '8761',
    '8760',
    '881',
    '8811',
    '8810',
    '886',
    '8860',
    '37572',
];
exports.STUDIO_PLUS_PLANS = [
    '842',
    '8420',
    '852',
    '8520',
    '857',
    '8570',
    '862',
    '8620',
    '867',
    '872',
    '8720',
    '877',
    '8771',
    '8770',
    '882',
    '8821',
    '8820',
    '887',
    '8870',
    '37573',
];
exports.STUDIO_ELITE_PLANS = [
    '843',
    '8430',
    '853',
    '8530',
    '858',
    '859',
    '863',
    '864',
    '868',
    '873',
    '8730',
    '878',
    '8780',
    '879',
    '883',
    '8830',
    '884',
    '888',
    '890',
    '37574',
];
exports.STUDIO_ENTERPRISE_PLANS = [
    '37575',
    '37576',
    '934',
    '844',
    '37577',
    '37578',
    '302',
];
exports.UNLIMITED_TO_CORE_PLANS = [
    '9310',
    '2244',
    '2239',
    '2214',
    '9311',
    '2209',
    '9312',
    '2210',
    '9313',
    '2243',
    '2236',
    '2211',
    '9314',
    '2212',
    '9315',
    '2213',
    '9410',
    '9800',
    '9510',
    '95100',
    '9511',
    '95110',
    '9512',
    '95120',
    '9610',
    '96100',
    '9611',
    '96110',
    '9612',
    '96120',
    '9710',
    '2245',
    '2242',
    '2217',
    '9711',
    '2215',
    '9712',
    '2216',
];
exports.EDITOR_X_PLANS = (_a = {},
    _a[types_1.ProductFamily.Boost] = ['598', '586', '555', '604', '592'],
    _a[types_1.ProductFamily.Essential] = ['594', '551', '588', '582', '600'],
    _a[types_1.ProductFamily.Extra] = ['552', '583', '589', '601', '595'],
    _a[types_1.ProductFamily.Launch] = ['585', '554', '591', '597', '603'],
    _a[types_1.ProductFamily.Scale] = ['605', '593', '556', '599', '587'],
    _a[types_1.ProductFamily.Ultra] = ['596', '553', '590', '584', '602'],
    _a[types_1.ProductFamily.Enterprise] = ['9998'],
    _a);
var SUNRISE_LIGHT_PLANS = [
    '930',
    '935',
    '940',
    '945',
    '950',
    '955',
    '960',
    '970',
    '974',
    '980',
    '2001',
    '2006',
    '2011',
    '2016',
    '2273',
    '1212',
    '20160',
    '2100',
    '2101',
    '2102',
    '2103',
    '2104',
    '2105',
    '2106',
    '37555',
    '2107',
    '2108',
    '2109',
    '2110',
    '2111',
    '2112',
    '2113',
    '2115',
    '2116',
    '2117',
    '2118',
    '37550',
    '2119',
    '2121',
    '2122',
    '2123',
    '37522',
    '37545',
    '2124',
    '37518',
    '37535',
    '2200',
    '22001',
    '37514',
    '37530',
    '22002',
    '2204',
    '2218',
    '2219',
    '2220',
    '2221',
    '2222',
    '2223',
    '2224',
    '2225',
    '2226',
    '9301',
    '9302',
    '9303',
    '9304',
    '9305',
    '9401',
    '9402',
    '9403',
    '9501',
    '9502',
    '9503',
    '9601',
    '9602',
    '9603',
    '9701',
    '9702',
    '9703',
    '9704',
    '9801',
    '9802',
    '9803',
    '9804',
    '95010',
    '95020',
    '95030',
    '96010',
    '96020',
    '96030',
    '37579'
];
var SUNRISE_CORE_PLANS = [
    '931',
    '936',
    '37523',
    '37546',
    '37547',
    '941',
    '946',
    '951',
    '956',
    '37527',
    '37541',
    '37542',
    '961',
    '971',
    '37556',
    '37557',
    '975',
    '981',
    '2002',
    '2007',
    '37580',
    '2077',
    '2017',
    '9921',
    '2201',
    '22011',
    '37515',
    '37531',
    '37532',
    '22012',
    '2206',
    '37519',
    '37536',
    '37537',
    '2209',
    '2210',
    '2211',
    '2212',
    '2213',
    '2214',
    '2215',
    '2216',
    '2217',
    '2236',
    '2237',
    '2238',
    '2239',
    '2240',
    '2241',
    '2242',
    '2243',
    '2244',
    '2245',
    '9310',
    '9311',
    '9312',
    '9313',
    '9314',
    '9315',
    '9316',
    '9317',
    '9410',
    '9411',
    '9412',
    '9413',
    '9920',
    '9510',
    '9511',
    '9512',
    '9513',
    '9514',
    '9515',
    '9924',
    '9610',
    '9611',
    '9612',
    '9613',
    '9614',
    '9615',
    '9923',
    '9710',
    '9711',
    '9712',
    '9713',
    '37551',
    '37552',
    '9922',
    '9714',
    '9715',
    '9750',
    '9800',
    '9807',
    '9808',
    '9900',
    '9901',
    '9902',
    '9903',
    '9904',
    '9915',
    '9916',
    '9917',
    '9918',
    '9919',
    '95100',
    '95110',
    '95120',
    '95130',
    '95140',
    '96100',
    '96110',
    '96120',
    '96130',
    '96140',
];
var SUNRISE_BUSINESS_PLANS = [
    '932',
    '937',
    '37524',
    '37548',
    '37549',
    '942',
    '947',
    '952',
    '957',
    '959',
    '37528',
    '37543',
    '37544',
    '962',
    '972',
    '37558',
    '37559',
    '976',
    '982',
    '37516',
    '37533',
    '37534',
    '2003',
    '2008',
    '2009',
    '2010',
    '2099',
    '2019',
    '9926',
    '2202',
    '2207',
    '37520',
    '37538',
    '37539',
    '2227',
    '2228',
    '2229',
    '2230',
    '2231',
    '2232',
    '2233',
    '2234',
    '2235',
    '2246',
    '2247',
    '2248',
    '2249',
    '9320',
    '9321',
    '9322',
    '9323',
    '9324',
    '9325',
    '9326',
    '9327',
    '9328',
    '9420',
    '9421',
    '9422',
    '9423',
    '9424',
    '9925',
    '9520',
    '9521',
    '9522',
    '9523',
    '9524',
    '9929',
    '9620',
    '9621',
    '9622',
    '9623',
    '9624',
    '9928',
    '9720',
    '9721',
    '37553',
    '37554',
    '9927',
    '9722',
    '9723',
    '9724',
    '9725',
    '9726',
    '9760',
    '9761',
    '9805',
    '9806',
    '9809',
    '9810',
    '9905',
    '9906',
    '9907',
    '9908',
    '9909',
    '9910',
    '9911',
    '9912',
    '9913',
    '9914',
    '95200',
    '95210',
    '95220',
    '95230',
    '96200',
    '96210',
    '96220',
    '96230',
];
var SUNRISE_BUSINESS_ELITE_PLANS = [
    '933',
    '37581',
    '938',
    '939',
    '943',
    '948',
    '953',
    '958',
    '37529',
    '963',
    '973',
    '37525',
    '977',
    '983',
    '37517',
    '2004',
    '2203',
    '2208',
    '37521',
];
var SUNRISE_ENTERPRISE_PLANS = ['934', '2005'];
exports.SUNRISE_PLANS = (_b = {},
    _b[types_1.ProductFamily.Light] = SUNRISE_LIGHT_PLANS,
    _b[types_1.ProductFamily.Core] = SUNRISE_CORE_PLANS,
    _b[types_1.ProductFamily.Business] = SUNRISE_BUSINESS_PLANS,
    _b[types_1.ProductFamily.Elite] = SUNRISE_BUSINESS_ELITE_PLANS,
    _b[types_1.ProductFamily.Enterprise] = SUNRISE_ENTERPRISE_PLANS,
    _b);
//# sourceMappingURL=products.js.map